import { useState, useEffect, useCallback, useRef } from 'react';
import API from '../api';
import html2canvas from 'html2canvas';
import { EmpresaDetalle } from './TecnicoPage';
import InventarioEquipos from '../components/InventarioEquipos';

const fmt = v => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(v || 0);

function CompactAutocomplete({ value, onChange, options, inputStyle, placeholder, newItemLabel, required = false }) {
  const [focused, setFocused] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const normalize = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const optionValue = option => typeof option === 'object' ? option.value : option;
  const optionLabel = option => typeof option === 'object' ? (option.label || option.value) : option;
  const optionSearch = option => typeof option === 'object' ? [option.label, option.value, option.search].filter(Boolean).join(' ') : option;
  const query = normalize(value);
  const matches = query.length >= 3
    ? (options || []).filter(option => normalize(optionSearch(option)).includes(query)).slice(0, 8)
    : [];
  const open = focused && query.length >= 3;

  function select(option) {
    onChange(optionValue(option));
    setFocused(false);
    setActiveIndex(-1);
  }

  function handleKeyDown(event) {
    if (!open || !matches.length) {
      if (event.key === 'Escape') setFocused(false);
      return;
    }
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setActiveIndex(index => Math.min(index + 1, matches.length - 1));
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setActiveIndex(index => Math.max(index - 1, 0));
    } else if (event.key === 'Enter' && activeIndex >= 0) {
      event.preventDefault();
      select(matches[activeIndex]);
    } else if (event.key === 'Escape') {
      setFocused(false);
      setActiveIndex(-1);
    }
  }

  return (
    <div style={{ position: 'relative' }}>
      <input
        className="input"
        value={value || ''}
        style={inputStyle}
        placeholder={placeholder || 'Escribe minimo 3 letras'}
        autoComplete="off"
        required={required}
        onFocus={() => setFocused(true)}
        onBlur={() => setTimeout(() => setFocused(false), 120)}
        onKeyDown={handleKeyDown}
        onChange={event => { onChange(event.target.value); setActiveIndex(-1); }}
      />
      {open && (
        <div style={{
          position: 'absolute', zIndex: 80, top: 'calc(100% + 4px)', left: 0, right: 0,
          background: '#fff', border: '1px solid #cfdde8', borderRadius: 3,
          boxShadow: '0 12px 28px rgba(8,41,63,0.18)', overflow: 'hidden',
        }}>
          {matches.map((option, index) => (
            <button
              key={`${optionValue(option)}-${index}`}
              type="button"
              onMouseDown={event => event.preventDefault()}
              onClick={() => select(option)}
              style={{
                display: 'block', width: '100%', padding: '9px 11px', textAlign: 'left',
                background: activeIndex === index ? '#eaf8fc' : '#fff',
                color: '#08293f', border: 'none', borderBottom: '1px solid #edf3f7',
                cursor: 'pointer', fontFamily: 'inherit', fontSize: 12, fontWeight: 600,
              }}
            >
              {optionLabel(option)}
            </button>
          ))}
          {!matches.length && (
            <div style={{ padding: '10px 11px', color: '#5a7a8a', fontSize: 11, lineHeight: 1.4 }}>
              Sin coincidencias. Puedes guardar "{String(value || '').trim()}" como {newItemLabel || 'elemento nuevo'}.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
const ESTADO_STYLE = {
  PAGADO:    { bg: 'rgba(0,184,227,0.12)',   color: '#00b8e3' },
  FACTURADO: { bg: 'rgba(99,102,241,0.12)',  color: '#6366f1' },
  PENDIENTE: { bg: 'rgba(251,191,36,0.12)',  color: '#b45309' },
};
function Tag({ text }) {
  const s = ESTADO_STYLE[text] || { bg: '#f4f7fa', color: '#5a7a8a' };
  return <span style={{ ...s, padding: '2px 7px', fontSize: 10, fontWeight: 600 }}>{text}</span>;
}

// Inventario equipos: la ficha, el acta de entrega y la exportacion viven
// en lib/equipos.js y components/FichaEquipo.js -- un solo comportamiento,
// sin importar si se llega por Clientes o por Empresas.


export function comprimirImagen(file, maxAncho = 900) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => {
      const img = new Image();
      img.onload = () => {
        let w = img.width, h = img.height;
        if (w > maxAncho) { h = Math.round(h * maxAncho / w); w = maxAncho; }
        const canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        resolve(canvas.toDataURL('image/png', 0.82));
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}


export function ModalMantenimiento({ equipo, nombre, origen, onClose, onGuardado }) {
  const hoy = new Date().toISOString().slice(0, 10);
  const [form, setForm] = useState({
    fecha: hoy, tipo_solicitud: 'preventivo', estado_inicial: 'funcional', estado_inicial_otro: '',
    insp_case: '', insp_puertos_usb: '', insp_teclado_mouse: '',
    insp_bateria_cargador: '', insp_adaptador_energia: '', insp_pantalla: '',
    insp_observaciones: '', actividades: '', diagnostico: '', observaciones: '',
    responsable: 'Ginel Alberto Garcia G. — Age Informatica',
  });
  const [foto1, setFoto1] = useState(null);
  const [foto2, setFoto2] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [msg, setMsg] = useState('');

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  // Cabecera de sección estilo reporte
  const Seccion = ({ titulo }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '18px 0 10px' }}>
      <div style={{ width: 3, height: 14, background: '#00b8e3', borderRadius: 2, flexShrink: 0 }} />
      <div style={{ fontSize: 9, fontWeight: 900, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#5a7a8a' }}>{titulo}</div>
      <div style={{ flex: 1, height: 1, background: '#e8eef2' }} />
    </div>
  );

  // Botones tipo-radio para selecciones
  const RadioBtns = ({ campo, opciones }) => (
    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
      {opciones.map(([val, label, color]) => {
        const activo = form[campo] === val;
        const c = color || '#00b8e3';
        return (
          <button key={val} type="button" onClick={() => set(campo, val)}
            style={{ fontSize: 11, fontWeight: 700, padding: '5px 12px', borderRadius: 3, cursor: 'pointer', fontFamily: 'inherit', transition: 'all 0.12s',
              border: `1.5px solid ${activo ? c : '#e8eef2'}`,
              background: activo ? c : '#f9fafb',
              color: activo ? '#fff' : '#5a7a8a' }}>
            {label}
          </button>
        );
      })}
    </div>
  );

  // Fila del checklist con botones B/R/M/NA
  const OPTS = [['B','Bueno'], ['R','Regular'], ['M','Malo'], ['NA','N/A']];
  const FilaInsp = ({ label, campo }) => (
    <tr style={{ borderBottom: '1px solid #f0f4f8' }}>
      <td style={{ padding: '7px 10px', fontSize: 12, color: '#08293f', fontWeight: 500 }}>{label}</td>
      <td style={{ padding: '4px 8px', textAlign: 'right' }}>
        <div style={{ display: 'flex', gap: 3, justifyContent: 'flex-end' }}>
          {OPTS.map(([val, title]) => {
            const activo = form[campo] === val;
            return (
              <button key={val} type="button" title={title} onClick={() => set(campo, activo ? '' : val)}
                style={{ fontSize: 10, fontWeight: 800, width: 30, height: 24, borderRadius: 3, cursor: 'pointer', fontFamily: 'inherit',
                  border: `1.5px solid ${activo ? '#00b8e3' : '#d8e5ec'}`,
                  background: activo ? '#00b8e3' : '#fff',
                  color: activo ? '#fff' : '#94a3b8' }}>
                {val}
              </button>
            );
          })}
        </div>
      </td>
    </tr>
  );

  const handleFoto = async (e, setFoto) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try { setFoto(await comprimirImagen(file)); }
    catch { alert('No se pudo procesar la imagen'); }
  };

  async function guardar(e) {
    e.preventDefault();
    setGuardando(true); setMsg('');
    try {
      await API.post(`/inventario/mantenimientos/${origen}/${equipo.id}`,
        { ...form, foto1: foto1 || null, foto2: foto2 || null });
      onGuardado(); onClose();
    } catch (err) {
      setMsg(err?.response?.data?.error || 'Error al guardar');
      setGuardando(false);
    }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,41,63,0.55)', zIndex: 20000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: '16px 10px', overflowY: 'auto' }}>
      <div style={{ background: '#fff', width: '100%', maxWidth: 700, margin: '0 auto 32px', boxShadow: '0 20px 60px rgba(8,41,63,0.28)', borderRadius: 4, overflow: 'hidden' }}>

        {/* ── Cabecera estilo reporte ── */}
        <div style={{ background: '#08293f', padding: '0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'stretch' }}>
            <div style={{ padding: '18px 22px', flex: 1 }}>
              <div style={{ fontSize: 8, fontWeight: 900, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(0,184,227,0.7)', marginBottom: 6 }}>
                AGE Informatica · Reporte de mantenimiento de equipos
              </div>
              <div style={{ fontSize: 17, fontWeight: 900, color: '#fff', lineHeight: 1.2 }}>
                {equipo.nombre_equipo || equipo.identidad_valor}
              </div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', marginTop: 5, display: 'flex', gap: 10 }}>
                <span>{nombre}</span>
                {equipo.area && <><span style={{ color: 'rgba(0,184,227,0.4)' }}>·</span><span>{equipo.area}</span></>}
                {equipo.responsable && <><span style={{ color: 'rgba(0,184,227,0.4)' }}>·</span><span>{equipo.responsable}</span></>}
              </div>
            </div>
            <div style={{ borderLeft: '1px solid rgba(255,255,255,0.07)', padding: '18px 20px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 6, minWidth: 140 }}>
              <div><div style={{ fontSize: 8, fontWeight: 800, letterSpacing: '0.1em', color: 'rgba(0,184,227,0.6)', marginBottom: 2 }}>CODIGO</div><div style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>AGE-001</div></div>
              <div><div style={{ fontSize: 8, fontWeight: 800, letterSpacing: '0.1em', color: 'rgba(0,184,227,0.6)', marginBottom: 2 }}>FECHA</div><div style={{ fontSize: 12, fontWeight: 700, color: '#fff' }}>{form.fecha}</div></div>
            </div>
            <button onClick={onClose}
              style={{ alignSelf: 'flex-start', margin: '14px 14px 0 0', fontSize: 18, color: 'rgba(255,255,255,0.4)', background: 'none', border: 'none', cursor: 'pointer', lineHeight: 1, padding: '2px 6px', borderRadius: 3 }}
              title="Cerrar">×</button>
          </div>
          <div style={{ height: 3, background: 'linear-gradient(90deg, #00b8e3, #0077a8)' }} />
        </div>

        <div style={{ padding: '6px 22px 24px' }}>

          {/* ── Tipo de solicitud ── */}
          <Seccion titulo="Tipo de solicitud" />
          <RadioBtns campo="tipo_solicitud" opciones={[
            ['preventivo',  'Mantenimiento preventivo', '#059669'],
            ['correctivo',  'Mantenimiento correctivo', '#dc2626'],
            ['verificacion','Verificacion',             '#6366f1'],
            ['ambos',       'Preventivo + Correctivo',  '#b45309'],
          ]} />

          {/* ── Información fecha + estado ── */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 14 }}>
            <div>
              <label className="label">Fecha del servicio *</label>
              <input type="date" className="input" value={form.fecha}
                onChange={e => set('fecha', e.target.value)}
                style={{ background: '#f9fafb', border: '1px solid #e8eef2' }} required />
            </div>
            <div>
              <label className="label">Estado inicial del equipo</label>
              <RadioBtns campo="estado_inicial" opciones={[
                ['funcional',   'Funcional',   '#059669'],
                ['no_enciende', 'No enciende', '#dc2626'],
                ['otro',        'Otro',        '#5a7a8a'],
              ]} />
              {form.estado_inicial === 'otro' && (
                <input className="input" value={form.estado_inicial_otro}
                  onChange={e => set('estado_inicial_otro', e.target.value)}
                  placeholder="Describir..." style={{ background: '#f9fafb', border: '1px solid #e8eef2', marginTop: 6, fontSize: 12 }} />
              )}
            </div>
          </div>

          {/* ── Verificación del equipo ── */}
          <Seccion titulo="Verificacion del equipo — B: Bueno / R: Regular / M: Malo / NA: No aplica" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[
              ['Inspeccion externa', [
                ['Case / gabinete', 'insp_case'],
                ['Puertos USB',     'insp_puertos_usb'],
                ['Teclado y Mouse', 'insp_teclado_mouse'],
              ]],
              ['Pruebas de funcionamiento', [
                ['Bateria / cargador',  'insp_bateria_cargador'],
                ['Adaptador de energia','insp_adaptador_energia'],
                ['Pantalla',            'insp_pantalla'],
              ]],
            ].map(([titulo, filas]) => (
              <div key={titulo} style={{ border: '1px solid #e8eef2', borderRadius: 3, overflow: 'hidden' }}>
                <div style={{ background: '#f4f7fa', padding: '7px 10px', fontSize: 9, fontWeight: 900, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a', borderBottom: '1px solid #e8eef2' }}>
                  {titulo}
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    {filas.map(([label, campo]) => <FilaInsp key={campo} label={label} campo={campo} />)}
                  </tbody>
                </table>
              </div>
            ))}
          </div>
          <div style={{ marginTop: 10 }}>
            <label className="label">Observaciones de la verificacion</label>
            <textarea className="input" rows={2} value={form.insp_observaciones}
              onChange={e => set('insp_observaciones', e.target.value)}
              style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit', fontSize: 12 }} />
          </div>

          {/* ── Actividades ── */}
          <Seccion titulo="Actividades realizadas" />
          <textarea className="input" rows={5} value={form.actividades}
            onChange={e => set('actividades', e.target.value)} required
            placeholder={'• Limpieza interna (motherboard, memorias, ventilador)\n• Cambio de pasta termica\n• Diagnostico de disco y velocidad de lectura\n• Actualizaciones Windows y drivers\n• Instalacion de software adicional'}
            style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit', fontSize: 12, lineHeight: 1.6 }} />

          {/* ── Diagnóstico + Observaciones ── */}
          <Seccion titulo="Diagnostico y observaciones" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <div>
              <label className="label">Detalle del diagnostico</label>
              <textarea className="input" rows={3} value={form.diagnostico}
                onChange={e => set('diagnostico', e.target.value)}
                placeholder="Estado del disco, temperaturas, rendimiento..."
                style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit', fontSize: 12 }} />
            </div>
            <div>
              <label className="label">Observaciones o recomendaciones</label>
              <textarea className="input" rows={3} value={form.observaciones}
                onChange={e => set('observaciones', e.target.value)}
                placeholder="Proximas acciones, repuestos necesarios..."
                style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit', fontSize: 12 }} />
            </div>
          </div>

          {/* ── Evidencia fotográfica ── */}
          <Seccion titulo="Evidencia fotografica" />
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            {[[foto1, setFoto1], [foto2, setFoto2]].map(([foto, setFoto], idx) => (
              <div key={idx}>
                <label className="label">Foto {idx + 1}</label>
                {!foto ? (
                  <label style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 6,
                    border: '2px dashed #d8e5ec', borderRadius: 4, padding: '18px 12px', cursor: 'pointer', background: '#f9fafb',
                    color: '#7f9aad', fontSize: 11, fontWeight: 600, transition: 'border-color 0.15s' }}
                    onMouseEnter={e => e.currentTarget.style.borderColor = '#00b8e3'}
                    onMouseLeave={e => e.currentTarget.style.borderColor = '#d8e5ec'}>
                    <span style={{ fontSize: 22 }}>📷</span>
                    <span>Seleccionar o capturar foto</span>
                    <span style={{ fontSize: 10, color: '#b3b3b3', fontWeight: 400 }}>Se comprime a PNG automaticamente</span>
                    <input type="file" accept="image/*" capture="environment" onChange={e => handleFoto(e, setFoto)} style={{ display: 'none' }} />
                  </label>
                ) : (
                  <div style={{ position: 'relative', borderRadius: 4, overflow: 'hidden', border: '1px solid #d8e5ec' }}>
                    <img src={foto} alt={`foto ${idx + 1}`} style={{ width: '100%', maxHeight: 160, objectFit: 'cover', display: 'block' }} />
                    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, background: 'rgba(8,41,63,0.72)', padding: '5px 10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <span style={{ fontSize: 10, color: 'rgba(0,184,227,0.9)', fontWeight: 700 }}>PNG comprimida</span>
                      <button type="button" onClick={() => setFoto(null)}
                        style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: 'rgba(220,38,38,0.8)', border: 'none', borderRadius: 3, padding: '2px 8px', cursor: 'pointer' }}>
                        Quitar
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* ── Responsable ── */}
          <Seccion titulo="Responsable del mantenimiento" />
          <input className="input" value={form.responsable}
            onChange={e => set('responsable', e.target.value)}
            style={{ background: '#f9fafb', border: '1px solid #e8eef2' }} />

          {/* ── Footer ── */}
          <div style={{ marginTop: 22, paddingTop: 16, borderTop: '1px solid #e8eef2', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
            {msg
              ? <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626' }}>{msg}</div>
              : <div style={{ fontSize: 11, color: '#b3b3b3' }}>Los campos marcados con * son obligatorios</div>
            }
            <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
              <button type="button" onClick={onClose} className="btn-secondary" disabled={guardando}>Cancelar</button>
              <button type="submit" onClick={guardar} disabled={guardando}
                className="btn-primary" style={{ padding: '8px 20px', opacity: guardando ? 0.7 : 1 }}>
                {guardando ? 'Guardando...' : 'Guardar ficha'}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

// ── Detalle de cliente ────────────────────────────────────────────
// Publicar una empresa/cliente en el modulo tecnico: que usuarios la ven y en que grupo.
// Lo usan la lista de Clientes y la ficha del cliente (boton Activar como empresa).
export function ModalPublicarTecnico({ nombre, onClose, onGuardado }) {
  const [usuarios, setUsuarios] = useState([]);
  const [ids, setIds] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    let vivo = true;
    Promise.all([
      API.get('/usuarios/tecnicos').then(r => (Array.isArray(r.data) ? r.data : [])).catch(() => []),
      API.get(`/tecnico/empresa-visible?empresa=${encodeURIComponent(nombre)}`)
        .then(r => (Array.isArray(r.data) ? r.data.map(item => String(item.usuario_id)) : []))
        .catch(err => { alert(err?.response?.data?.error || 'No se pudieron consultar los permisos actuales'); return []; }),
    ]).then(([lista, asignados]) => {
      if (!vivo) return;
      setUsuarios(lista);
      setIds(asignados);
      setCargando(false);
    });
    return () => { vivo = false; };
  }, [nombre]);

  const toggle = id => {
    const str = String(id);
    setIds(prev => (prev.includes(str) ? prev.filter(x => x !== str) : [...prev, str]));
  };

  async function activarEnGrupo(grupo) {
    setGuardando(true);
    try {
      await Promise.all(usuarios.map(u => API.put('/tecnico/empresa-visible', {
        empresa: nombre,
        visible: ids.includes(String(u.id)),
        grupo,
        usuario_id: Number(u.id),
      })));
      onGuardado();
    } catch (err) {
      alert(err?.response?.data?.error || 'No se pudieron actualizar los permisos');
    } finally {
      setGuardando(false);
    }
  }

  return (
  <div style={{ position: 'fixed', inset: 0, background: 'rgba(8,41,63,0.45)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ width: '100%', maxWidth: 420, background: '#fff', border: '1px solid #d8e5ec', borderRadius: 6, padding: 18, boxShadow: '0 18px 45px rgba(8,41,63,0.22)' }}>
              <div style={{ fontSize: 11, fontWeight: 800, color: '#5a7a8a', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 6 }}>Publicar en módulo técnico</div>
              <div style={{ fontSize: 16, fontWeight: 800, color: '#08293f', marginBottom: 12 }}>{nombre}</div>
              <label style={{ fontSize: 11, color: '#5a7a8a', fontWeight: 700, display: 'block', marginBottom: 6 }}>Usuarios que la verán</label>
              <div style={{ display: 'grid', gap: 6, marginBottom: 12, opacity: cargando ? 0.55 : 1 }}>
                {usuarios.map(u => {
                  const checked = ids.includes(String(u.id));
                  return (
                    <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '8px 10px', border: `1px solid ${checked ? 'rgba(0,184,227,0.35)' : '#d8e5ec'}`, borderRadius: 4, background: checked ? 'rgba(0,184,227,0.07)' : '#fff', cursor: 'pointer', color: '#08293f', fontWeight: 700 }}>
                      <input type="checkbox" checked={checked} disabled={cargando} onChange={() => toggle(u.id)} />
                      <span>{u.nombre} - {u.rol}</span>
                    </label>
                  );
                })}
              </div>
              {cargando && <div style={{ fontSize: 11, color: '#5a7a8a', marginBottom: 10 }}>Consultando permisos actuales...</div>}
              <div style={{ display: 'flex', gap: 6, marginBottom: 12 }}>
                <button type="button" onClick={() => setIds(usuarios.map(u => String(u.id)))} style={{ fontSize: 11, fontWeight: 700, color: '#5a7a8a', background: '#f4f7fa', border: '1px solid #d8e5ec', borderRadius: 4, padding: '5px 9px', cursor: 'pointer' }}>Todos</button>
                <button type="button" onClick={() => setIds([])} style={{ fontSize: 11, fontWeight: 700, color: '#5a7a8a', background: '#f4f7fa', border: '1px solid #d8e5ec', borderRadius: 4, padding: '5px 9px', cursor: 'pointer' }}>Limpiar</button>
              </div>
              <div style={{ display: 'grid', gap: 8 }}>
                {GRUPOS_TECNICOS.map(grupo => (
                  <button key={grupo} disabled={cargando || guardando} onClick={() => activarEnGrupo(grupo)} style={{ textAlign: 'left', background: grupo === 'Empresas' ? '#08293f' : '#f4f7fa', color: grupo === 'Empresas' ? '#fff' : '#08293f', border: '1px solid #d8e5ec', borderRadius: 4, padding: '10px 12px', cursor: cargando ? 'default' : 'pointer', fontWeight: 700, opacity: cargando ? 0.55 : 1 }}>
                    {grupo}
                  </button>
                ))}
              </div>
              <button onClick={onClose} style={{ marginTop: 12, background: 'transparent', border: 'none', color: '#5a7a8a', cursor: 'pointer', fontWeight: 700 }}>Cancelar</button>
            </div>
          </div>
  );
}

// Sesion minima para decidir permisos de la parte tecnica dentro de la ficha.
function leerSesion() {
  try {
    const permisos = JSON.parse(localStorage.getItem('permisos') || '[]');
    const isAdmin = localStorage.getItem('rol') === 'admin';
    return { isAdmin, canDeleteInventory: isAdmin || (Array.isArray(permisos) && permisos.includes('inventario.eliminar')) };
  } catch (_) {
    return { isAdmin: false, canDeleteInventory: false };
  }
}

// Ficha unica del cliente. Las secciones tecnicas (accesos, inventario, registro tecnico)
// solo aparecen si es una empresa: activada para tecnico, o con equipos/accesos cargados,
// y no marcada como cliente individual.
// tabInicial='tecnico' (entrada desde el tablero de Empresas) la trata siempre como empresa.
export function DetalleCliente({ nombre, onClose, todosLosClientes: clientesProp, onRenombrado, tabInicial = 'info', volverLabel = 'Volver a clientes' }) {
  const sesion = leerSesion();
  const [clientesCargados, setClientesCargados] = useState([]);
  const todosLosClientes = clientesProp || clientesCargados;
  useEffect(() => {
    if (clientesProp) return;
    API.get('/clientes').then(r => setClientesCargados(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  }, [clientesProp]);
  const [tecnicoInfo, setTecnicoInfo] = useState({ activo: false, equipos: 0, accesos: 0, cargado: false });
  const [publicarTecnico, setPublicarTecnico] = useState(false);
  const cargarTecnicoInfo = useCallback(() => {
    const enc = encodeURIComponent(nombre);
    return Promise.all([
      API.get(`/clientes/${enc}/inventario`).then(r => (Array.isArray(r.data) ? r.data.length : 0)).catch(() => 0),
      API.get('/empresa-accesos', { params: { empresa: nombre } }).then(r => (Array.isArray(r.data) ? r.data.length : 0)).catch(() => 0),
      API.get('/tecnico/empresa-visible', { params: { empresa: nombre } }).then(r => Array.isArray(r.data) && r.data.length > 0).catch(() => false),
    ]).then(([equipos, accesos, activo]) => setTecnicoInfo({ activo, equipos, accesos, cargado: true }));
  }, [nombre]);
  useEffect(() => { cargarTecnicoInfo(); }, [cargarTecnicoInfo]);
  const [data,        setData]        = useState(null);
  const [nota,        setNota]        = useState('');
  const [showRename,  setShowRename]  = useState(false);
  const [nuevoNombre, setNuevoNombre] = useState(nombre);
  const [showUnif,    setShowUnif]    = useState(false);
  const [destino,     setDestino]     = useState('');
  const [copied,      setCopied]      = useState(null);
  const [infoForm,    setInfoForm]    = useState({ nit: '', direccion: '', correo: '', descripcion_cliente: '', descripcion_servicios: '' });
  const [infoMsg,     setInfoMsg]     = useState('');
  const [savingInfo,  setSavingInfo]  = useState(false);
  const [individual,        setIndividual]        = useState(false);
  const [tabActiva,         setTabActiva]         = useState(tabInicial);
  const [expandirServicios, setExpandirServicios] = useState(false);

  const cargar = useCallback(() => {
    API.get(`/clientes/${encodeURIComponent(nombre)}/detalle`).then(r => setData(r.data));
  }, [nombre]);
  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => { if (data?.info) setInfoForm({ nit: data.info.nit || '', direccion: data.info.direccion || '', correo: data.info.correo || '', descripcion_cliente: data.info.descripcion_cliente || '', descripcion_servicios: data.info.descripcion_servicios || '' }); }, [data]);
  useEffect(() => {
    API.get(`/clientes/${encodeURIComponent(nombre)}/individual`).then(r => setIndividual(r.data.individual)).catch(() => {});
  }, [nombre]);

  async function toggleIndividual() {
    const nuevo = !individual;
    setIndividual(nuevo);
    try { await API.put(`/clientes/${encodeURIComponent(nombre)}/individual`, { individual: nuevo }); }
    catch { setIndividual(!nuevo); }
  }

  async function agregarNota(e) {
    e.preventDefault();
    if (!nota.trim()) return;
    await API.post(`/clientes/${encodeURIComponent(nombre)}/notas`, { nota });
    setNota(''); cargar();
  }

  async function borrarNota(id) {
    await API.delete(`/clientes/notas/${id}`); cargar();
  }

  async function guardarInfoCliente(e) {
    e.preventDefault();
    setInfoMsg('');
    setSavingInfo(true);
    try {
      await API.put(`/clientes/${encodeURIComponent(nombre)}/info`, infoForm);
      setInfoMsg('Guardado');
      cargar();
    } catch (err) {
      setInfoMsg(err?.response?.data?.error || 'No se pudo guardar');
    } finally {
      setSavingInfo(false);
    }
  }

  async function renombrar(e) {
    e.preventDefault();
    if (!nuevoNombre.trim() || nuevoNombre === nombre) return;
    await API.post('/clientes/renombrar', { nombre_actual: nombre, nombre_nuevo: nuevoNombre.trim() });
    onRenombrado();
  }

  async function unificar(e) {
    e.preventDefault();
    if (!destino || destino === nombre) return;
    if (!window.confirm(`¿Mover todos los registros de "${nombre}" hacia "${destino}"? Esta acción no se puede deshacer.`)) return;
    await API.post('/clientes/unificar', { cliente_origen: nombre, cliente_destino: destino });
    onRenombrado();
  }

  if (!data) return <div style={{ textAlign: 'center', padding: 40, color: '#b3b3b3' }}>Cargando...</div>;

  // Empresa = activada para tecnico (o con accesos cargados) y no marcada como individual.
  // Los equipos de un cliente que no es empresa (p. ej. un cliente individual) se ven y se
  // administran en la pestana Equipos, con el mismo inventario e historial; en una empresa ese
  // inventario vive dentro de la pestana Tecnico.
  const esEmpresa = tabInicial === 'tecnico' || (!individual && (tecnicoInfo.activo || tecnicoInfo.accesos > 0));
  const tab = tabActiva === 'tecnico' && !esEmpresa ? 'equipos' : tabActiva === 'equipos' && esEmpresa ? 'tecnico' : tabActiva;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      {/* Header */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <button onClick={onClose} style={{
          alignSelf: 'flex-start', display: 'flex', alignItems: 'center', gap: 5,
          fontSize: 11, fontWeight: 600, color: '#5a7a8a',
          background: '#f4f7fa', border: '1px solid #e8eef2',
          padding: '4px 10px', borderRadius: 2, cursor: 'pointer'
        }}>← {volverLabel}</button>
        <div>
          <h2 style={{ fontSize: 16, fontWeight: 700, color: '#08293f', margin: 0 }}>{nombre}</h2>
          <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 2 }}>{data.stats.total} registros en total</div>
        </div>
      </div>

      {(() => {
        const castigos = (data.registros || []).filter(r => r.castigado);
        if (!castigos.length) return null;
        const total = castigos.reduce((s, r) => s + (parseFloat(r.valor) || 0), 0);
        return (
          <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.35)', borderRadius: 2, padding: '14px 16px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <span style={{ fontSize: 15 }}>⚠️</span>
              <div style={{ fontSize: 12, fontWeight: 800, color: '#dc2626' }}>
                Cartera castigada — {castigos.length} servicio(s) por {fmt(total)}
              </div>
            </div>
            <div style={{ fontSize: 11, color: '#9a3a3a', marginBottom: 10 }}>
              Este cliente dejó de pagar los siguientes servicios y se marcaron como no cobrables. Si vuelve a solicitar algo, esto es lo que debía:
            </div>
            <div style={{ display: 'grid', gap: 6 }}>
              {castigos.map(c => (
                <div key={c.id} style={{ background: '#fff', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 2, padding: '8px 10px', fontSize: 11 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontWeight: 700, color: '#08293f' }}>
                    <span>{c.servicio}</span>
                    <span style={{ color: '#dc2626' }}>{fmt(c.valor)}</span>
                  </div>
                  <div style={{ color: '#5a7a8a', marginTop: 3 }}>
                    Servicio del {c.fecha?.slice(0,10)} · castigado el {c.castigado_fecha?.slice(0,10)} por {c.castigado_usuario || '—'}
                  </div>
                  {c.castigado_motivo && <div style={{ color: '#9a3a3a', marginTop: 3, fontStyle: 'italic' }}>"{c.castigado_motivo}"</div>}
                </div>
              ))}
            </div>
          </div>
        );
      })()}

      {/* Toggle individual + tabs */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
        <div style={{ display: 'flex', gap: 4 }}>
          {[{ key:'info', label:'Información' }, ...(esEmpresa ? [{ key:'tecnico', label:'Ficha' }] : tecnicoInfo.cargado ? [{ key:'equipos', label:'Equipos' }] : []), { key:'cotizaciones', label:'Cotizaciones' }].map(t => (
            <button key={t.key} onClick={() => setTabActiva(t.key)} style={{
              fontSize: 11, fontWeight: 700, padding: '5px 14px', borderRadius: 2, border: 'none', cursor: 'pointer',
              background: tab === t.key ? '#08293f' : '#f4f7fa',
              color: tab === t.key ? '#00b8e3' : '#5a7a8a',
            }}>
              {t.label}
            </button>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {sesion.isAdmin && !individual && (
          <button onClick={() => setPublicarTecnico(true)} style={{
            fontSize: 11, fontWeight: 600, padding: '5px 12px', borderRadius: 2, cursor: 'pointer',
            background: tecnicoInfo.activo ? 'rgba(15,118,110,0.08)' : 'rgba(0,184,227,0.08)',
            border: tecnicoInfo.activo ? '1px solid rgba(15,118,110,0.25)' : '1px solid rgba(0,184,227,0.3)',
            color: tecnicoInfo.activo ? '#0f766e' : '#0087a8',
          }}>
            {tecnicoInfo.activo ? '✓ Empresa activa (editar)' : 'Activar como empresa'}
          </button>
        )}
        <button onClick={toggleIndividual} style={{
          fontSize: 11, fontWeight: 600, padding: '5px 12px', borderRadius: 2, cursor: 'pointer',
          background: individual ? 'rgba(5,150,105,0.08)' : '#f4f7fa',
          border: individual ? '1px solid rgba(5,150,105,0.25)' : '1px solid #e8eef2',
          color: individual ? '#059669' : '#5a7a8a',
        }}>
          {individual ? '✓ Cliente individual' : 'Marcar como individual'}
        </button>
        </div>
      </div>

      {publicarTecnico && <ModalPublicarTecnico nombre={nombre} onClose={() => setPublicarTecnico(false)} onGuardado={() => { setPublicarTecnico(false); cargarTecnicoInfo(); }} />}
      {tab === 'equipos' && !esEmpresa && <InventarioEquipos empresa={nombre} fuente="clientes" canDelete={sesion.canDeleteInventory} canUnificar />}
      {tab === 'tecnico' && esEmpresa && <EmpresaDetalle empresa={nombre} embedded isAdmin={sesion.isAdmin} canDeleteInventory={sesion.canDeleteInventory} />}
      {tab === 'cotizaciones' && <TabCotizaciones clienteFijo={nombre} />}

      {tab === 'info' && <>

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8 }}>
        {[
          { label: 'Total facturado', value: fmt(data.stats.valor),    color: '#08293f', dark: true },
          { label: 'Utilidad',        value: fmt(data.stats.utilidad),  color: '#059669' },
          { label: 'Por cobrar',      value: fmt(data.stats.pendiente), color: data.stats.pendiente > 0 ? '#dc2626' : '#5a7a8a' },
        ].map((k, i) => (
          <div key={i} style={{ background: k.dark ? '#08293f' : '#fff', border: k.dark ? '1px solid rgba(0,184,227,0.2)' : '1px solid #e8eef2', padding: '12px 14px', borderRadius: 2 }}>
            <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: k.dark ? 'rgba(0,184,227,0.6)' : '#5a7a8a', marginBottom: 3 }}>{k.label}</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: k.dark ? '#00b8e3' : k.color }}>{k.value}</div>
          </div>
        ))}
      </div>

      {/* Corrección nombre + Unificación */}
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { setShowRename(r => !r); setShowUnif(false); }} style={{
          fontSize: 11, fontWeight: 600, color: '#6366f1', background: 'rgba(99,102,241,0.07)',
          border: '1px solid rgba(99,102,241,0.2)', padding: '5px 12px', cursor: 'pointer', borderRadius: 2 }}>
          ✏ Corregir nombre
        </button>
        <button onClick={() => { setShowUnif(u => !u); setShowRename(false); }} style={{
          fontSize: 11, fontWeight: 600, color: '#b45309', background: 'rgba(251,191,36,0.08)',
          border: '1px solid rgba(251,191,36,0.25)', padding: '5px 12px', cursor: 'pointer', borderRadius: 2 }}>
          ⇒ Unificar con otro
        </button>
      </div>

      {showRename && (
        <form onSubmit={renombrar} style={{ display: 'flex', gap: 8, padding: '10px 14px', background: 'rgba(99,102,241,0.04)', borderRadius: 2, border: '1px solid rgba(99,102,241,0.15)' }}>
          <input className="input" value={nuevoNombre} onChange={e => setNuevoNombre(e.target.value)}
            style={{ flex: 1, background: '#f9fafb', border: '1px solid #e8eef2' }} placeholder="Nombre correcto" />
          <button type="submit" className="btn-primary" style={{ padding: '6px 14px', fontSize: 12 }}>Actualizar todos los registros</button>
          <button type="button" className="btn-secondary" onClick={() => setShowRename(false)}>×</button>
        </form>
      )}

      {showUnif && (
        <form onSubmit={unificar} style={{ display: 'flex', gap: 8, padding: '10px 14px', background: 'rgba(251,191,36,0.04)', borderRadius: 2, border: '1px solid rgba(251,191,36,0.2)' }}>
          <div style={{ fontSize: 11, color: '#b45309', alignSelf: 'center', whiteSpace: 'nowrap' }}>Mover hacia:</div>
          <input className="input" list="unif-destino-list" value={destino} onChange={e => setDestino(e.target.value)}
            style={{ flex: 1, background: '#f9fafb', border: '1px solid #e8eef2' }}
            placeholder="Escribir para buscar cliente..." required />
          <datalist id="unif-destino-list">
            {todosLosClientes.filter(c => c.cliente !== nombre).map(c => (
              <option key={c.cliente} value={c.cliente} />
            ))}
          </datalist>
          <button type="submit" className="btn-primary" style={{ padding: '6px 14px', fontSize: 12, background: '#b45309', borderColor: '#b45309' }}>Unificar</button>
          <button type="button" className="btn-secondary" onClick={() => setShowUnif(false)}>×</button>
        </form>
      )}



      {/* Ficha del cliente */}
      <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '14px 16px' }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 10 }}>— Informacion del cliente</div>
        <form onSubmit={guardarInfoCliente} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 8, alignItems: 'end' }} className="cot-form-grid">
          <div>
            <label className="label">NIT / CC</label>
            <input className="input" value={infoForm.nit} onChange={e => setInfoForm(f => ({ ...f, nit: e.target.value }))} placeholder="NIT o documento" style={{ background: '#f9fafb', border: '1px solid #e8eef2' }} />
          </div>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
              <label className="label" style={{ margin: 0 }}>Dirección</label>
              {infoForm.direccion && (
                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(infoForm.direccion + ', Medellín, Colombia')}`}
                  target="_blank" rel="noopener noreferrer"
                  style={{ fontSize: 10, color: '#00b8e3', fontWeight: 700, textDecoration: 'none' }}>Ver en mapa</a>
              )}
            </div>
            <input className="input" value={infoForm.direccion} onChange={e => setInfoForm(f => ({ ...f, direccion: e.target.value }))} placeholder="Dirección" style={{ background: '#f9fafb', border: '1px solid #e8eef2' }} />
          </div>
          <div>
            <label className="label">Correo</label>
            <input className="input" type="email" value={infoForm.correo} onChange={e => setInfoForm(f => ({ ...f, correo: e.target.value }))} placeholder="correo@cliente.com" style={{ background: '#f9fafb', border: '1px solid #e8eef2' }} />
          </div>
          <button type="submit" disabled={savingInfo} className="btn-primary" style={{ padding: '8px 14px', fontSize: 12, opacity: savingInfo ? 0.7 : 1 }}>{savingInfo ? 'Guardando...' : 'Guardar'}</button>
          <div style={{ gridColumn: '1/-1' }}>
            <label className="label">Descripcion del cliente (que hace, sector)</label>
            <textarea className="input" rows={2} value={infoForm.descripcion_cliente} onChange={e => setInfoForm(f => ({ ...f, descripcion_cliente: e.target.value }))} placeholder="Ej: Empresa de transporte de carga, sector logistico..." style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit' }} />
          </div>
          <div style={{ gridColumn: '1/-1' }}>
            <label className="label">Servicios que se le prestan</label>
            <textarea className="input" rows={2} value={infoForm.descripcion_servicios} onChange={e => setInfoForm(f => ({ ...f, descripcion_servicios: e.target.value }))} placeholder="Ej: Mantenimiento preventivo mensual, soporte remoto, renovacion licencias..." style={{ background: '#f9fafb', border: '1px solid #e8eef2', resize: 'vertical', fontFamily: 'inherit' }} />
          </div>
        </form>
        {infoMsg && <div style={{ marginTop: 8, fontSize: 11, fontWeight: 700, color: infoMsg === 'Guardado' ? '#059669' : '#dc2626' }}>{infoMsg}</div>}
      </div>

      {/* Notas */}
      <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '14px 16px' }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 10 }}>— Anotaciones</div>
        <form onSubmit={agregarNota} style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
          <input className="input" value={nota} onChange={e => setNota(e.target.value)} placeholder="Agregar anotación..."
            style={{ flex: 1, background: '#f9fafb', border: '1px solid #e8eef2' }} />
          <button type="submit" className="btn-primary" style={{ padding: '6px 14px', fontSize: 12 }}>+ Agregar</button>
        </form>
        {data.notas.length === 0 && <div style={{ fontSize: 11, color: '#b3b3b3' }}>Sin anotaciones</div>}
        {data.notas.map(n => (
          <div key={n.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', padding: '8px 0', borderTop: '1px solid #f4f7fa' }}>
            <div>
              <div style={{ fontSize: 12, color: '#08293f' }}>{n.nota}</div>
              <div style={{ fontSize: 10, color: '#b3b3b3', marginTop: 2 }}>{new Date(n.created_at).toLocaleDateString('es-CO')}</div>
            </div>
            <button onClick={() => borrarNota(n.id)} style={{ fontSize: 11, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
          </div>
        ))}
      </div>

      {/* Historial */}
      <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px' }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Historial de servicios</div>
          {data.registros.length > 5 && (
            <button onClick={() => setExpandirServicios(e => !e)}
              style={{ fontSize: 11, fontWeight: 700, color: '#5a7a8a', background: '#f4f7fa', border: '1px solid #e8eef2', padding: '3px 10px', borderRadius: 2, cursor: 'pointer' }}>
              {expandirServicios ? 'Comprimir' : `Ver todos (${data.registros.length})`}
            </button>
          )}
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead>
              <tr style={{ background: '#f9fafb' }}>
                {['Fecha','Servicio','Valor','Utilidad','Estado'].map(h => (
                  <th key={h} style={{ padding: '7px 12px', fontSize: 10, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#5a7a8a', textAlign: h === 'Valor' || h === 'Utilidad' ? 'right' : 'left', borderBottom: '1px solid #e8eef2' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {(expandirServicios ? data.registros : data.registros.slice(0, 5)).map(r => (
                <tr key={r.id} style={{ borderBottom: '1px solid #f4f7fa' }}>
                  <td style={{ padding: '8px 12px', color: '#5a7a8a', whiteSpace: 'nowrap' }}>{r.fecha?.slice(0,10)}</td>
                  <td style={{ padding: '8px 12px', color: '#08293f' }}>{r.servicio_organizado || r.servicio || '—'}</td>
                  <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 600 }}>{fmt(r.valor)}</td>
                  <td style={{ padding: '8px 12px', textAlign: 'right', color: '#059669' }}>{fmt(r.utilidad)}</td>
                  <td style={{ padding: '8px 12px' }}><Tag text={r.estado} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!expandirServicios && data.registros.length > 5 && (
          <div style={{ padding: '8px 16px', borderTop: '1px solid #f4f7fa', textAlign: 'center' }}>
            <button onClick={() => setExpandirServicios(true)}
              style={{ fontSize: 11, fontWeight: 700, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              + {data.registros.length - 5} servicios mas
            </button>
          </div>
        )}
      </div>

      </>}
    </div>
  );
}

// ── Tab Todos los clientes ────────────────────────────────────────
const ORDEN_OPTS = [
  { value: 'valor_desc', label: 'Mayor ingreso' },
  { value: 'valor_asc', label: 'Menor ingreso' },
  { value: 'fecha_desc', label: 'Fecha: más reciente' },
  { value: 'fecha_asc', label: 'Fecha: más antigua' },
  { value: 'az', label: 'Nombre: A → Z' },
  { value: 'za', label: 'Nombre: Z → A' },
];

const ANIOS_CLIENTES = Array.from({ length: new Date().getFullYear() - 2018 }, (_, i) => new Date().getFullYear() - i);
const GRUPOS_TECNICOS = ['Empresas', 'Pedidos empresariales', 'Ageinformatica / Usuarios independientes'];

function TabClientes() {
  const [clientes,     setClientes]     = useState([]);
  const [grupos,       setGrupos]       = useState([]);
  const [buscar,       setBuscar]       = useState('');
  const [orden,        setOrden]        = useState('valor_desc');
  const [anio,         setAnio]         = useState(String(new Date().getFullYear()));
  const [seleccionado, setSeleccionado] = useState(null);
  const [expandido,    setExpandido]    = useState(null);
  const [unificando,   setUnificando]   = useState(null);
  const [destUnif,     setDestUnif]     = useState('');
  const [editando,     setEditando]     = useState(null); // { tipo:'cliente'|'grupo', id, nombre }
  const [editNombre,   setEditNombre]   = useState('');
  const [activarTecnico, setActivarTecnico] = useState(null);
  const [clienteDash, setClienteDash] = useState({ activos: 0, nuevos: 0, reactivados: 0, recurrentes: 0, mes_actual: 0, nuevos_clientes: [], reactivados_clientes: [] });
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [clientesFijosNombres, setClientesFijosNombres] = useState(new Set());
  const [vista, setVista] = useState('tarjetas'); // 'lista' | 'tarjetas'
  const [expandServicios, setExpandServicios] = useState(false);
  const [filtroActividad, setFiltroActividad] = useState('todos');
  const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
  const [cargandoDetalle, setCargandoDetalle] = useState(false);
  const [clienteCastigos, setClienteCastigos] = useState(null);
  const [vistaCompleta, setVistaCompleta] = useState(false);
  const [registroEditando, setRegistroEditando] = useState(null);
  const [registroCliente, setRegistroCliente] = useState('');
  const [guardandoRegistro, setGuardandoRegistro] = useState(false);
  const [registroMsg, setRegistroMsg] = useState('');

  // Al escribir en el buscador se busca en TODOS los años (un cliente sin movimiento este año
  // tambien debe aparecer); al borrar el texto vuelve el filtro de año/fechas.
  const [buscaTodos, setBuscaTodos] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setBuscaTodos(buscar.trim().length >= 2), 350);
    return () => clearTimeout(t);
  }, [buscar]);

  const cargar = useCallback(() => {
    const params = new URLSearchParams();
    if (!buscaTodos) {
      if (anio) params.append('anio', anio);
      if (fechaDesde) params.append('fecha_desde', fechaDesde);
      if (fechaHasta) params.append('fecha_hasta', fechaHasta);
    }
    const url = `/clientes${params.toString() ? '?' + params.toString() : ''}`;
    Promise.all([API.get(url), API.get('/clientes/grupos')])
      .then(([c, g]) => { setClientes(c.data); setGrupos(g.data); });
  }, [anio, fechaDesde, fechaHasta, buscaTodos]);
  useEffect(() => { cargar(); }, [cargar]);
  useEffect(() => {
    API.get('/clientes-fijos').then(r => {
      const nombres = Array.isArray(r.data) ? r.data.map(f => f.cliente) : [];
      setClientesFijosNombres(new Set(nombres));
    }).catch(() => {});
  }, []);

  useEffect(() => {
    const url = anio ? `/clientes/dashboard?anio=${anio}` : '/clientes/dashboard';
    API.get(url)
      .then(r => setClienteDash({
        activos: Number(r.data?.activos || 0),
        nuevos: Number(r.data?.nuevos || 0),
        reactivados: Number(r.data?.reactivados || 0),
        recurrentes: Number(r.data?.recurrentes || 0),
        mes_actual: Number(r.data?.mes_actual || 0),
        nuevos_clientes: Array.isArray(r.data?.nuevos_clientes) ? r.data.nuevos_clientes : [],
        reactivados_clientes: Array.isArray(r.data?.reactivados_clientes) ? r.data.reactivados_clientes : [],
      }))
      .catch(() => setClienteDash({ activos: 0, nuevos: 0, reactivados: 0, recurrentes: 0, mes_actual: 0, nuevos_clientes: [], reactivados_clientes: [] }));
  }, [anio]);

  async function confirmarUnificacion() {
    if (!destUnif || !unificando) return;
    if (!window.confirm(`¿Mover todos los registros de "${unificando.cliente}" hacia "${destUnif}"? Los registros quedan separados bajo el mismo nombre.`)) return;
    await API.post('/clientes/unificar', { cliente_origen: unificando.cliente, cliente_destino: destUnif });
    setUnificando(null); setDestUnif(''); cargar();
  }

  function abrirEdicion(tipo, id, nombre, e) {
    e.stopPropagation();
    setEditando({ tipo, id, nombre });
    setEditNombre(nombre);
  }

  function cambiarVisibilidadTecnica(cliente) {
    if (cliente.cliente) setActivarTecnico(cliente);
  }

  function TecnicoBtn({ cliente }) {
    const activo = !!cliente.tecnico_visible;
    return <button onClick={e => { e.stopPropagation(); cambiarVisibilidadTecnica(cliente); }} style={{ fontSize: 10, fontWeight: 700, color: activo ? '#0f766e' : '#5a7a8a', background: activo ? 'rgba(15,118,110,0.08)' : '#f4f7fa', border: `1px solid ${activo ? 'rgba(15,118,110,0.22)' : '#e8eef2'}`, padding: '4px 8px', cursor: 'pointer', borderRadius: 2, whiteSpace: 'nowrap' }}>{activo ? `Técnico: ${cliente.tecnico_grupo || 'Empresas'}` : 'Activar técnico'}</button>;
  }

  async function guardarEdicion(e) {
    e.preventDefault(); e.stopPropagation();
    if (!editNombre.trim() || editNombre.trim() === editando.nombre) { setEditando(null); return; }
    if (editando.tipo === 'cliente') {
      await API.post('/clientes/renombrar', { nombre_actual: editando.nombre, nombre_nuevo: editNombre.trim() });
    } else {
      await API.put(`/clientes/grupos/${editando.id}`, { nombre: editNombre.trim() });
    }
    setEditando(null); cargar();
  }

  function abrirEditarRegistro(r) {
    setRegistroEditando(r);
    setRegistroCliente(r.cliente || clienteSeleccionado?.cliente || '');
    setRegistroMsg('');
  }

  async function guardarRegistroIndividual(e) {
    e.preventDefault();
    if (!registroEditando || !registroCliente.trim()) return;
    const nuevoCliente = registroCliente.trim();
    setGuardandoRegistro(true);
    setRegistroMsg('');
    try {
      await API.put(`/registros/${registroEditando.id}`, {
        fecha: String(registroEditando.fecha || '').slice(0, 10),
        cliente: nuevoCliente,
        servicio: registroEditando.servicio || '',
        tipo: registroEditando.tipo || 'PARTICULAR',
        valor: registroEditando.valor || 0,
        costo: registroEditando.costo || 0,
        comision_pct: registroEditando.comision_pct || 0,
        factura: (registroEditando.factura === 'SI' || registroEditando.factura === 'SÍ') ? 'SI' : 'NO',
        con_iva: registroEditando.con_iva ?? 1,
        estado: registroEditando.estado || 'PENDIENTE',
        notas: registroEditando.notas || '',
        solicitante: registroEditando.solicitante || null,
        numero_factura: registroEditando.numero_factura || null,
        codigo_dian: registroEditando.codigo_dian || null,
        proveedor: registroEditando.proveedor || 'Ageinformatica',
      });
      setRegistroEditando(null);
      setRegistroCliente('');
      setSeleccionado(nuevoCliente);
      cargar();
    } catch (err) {
      setRegistroMsg(err?.response?.data?.error || 'No se pudo guardar el registro');
    } finally {
      setGuardandoRegistro(false);
    }
  }

  const nombresFiltroActividad = filtroActividad === 'nuevos'
    ? new Set(clienteDash.nuevos_clientes || [])
    : filtroActividad === 'reactivados'
      ? new Set(clienteDash.reactivados_clientes || [])
      : filtroActividad === 'empresariales'
        ? clientesFijosNombres
        : null;
  const clientesActividad = nombresFiltroActividad ? clientes.filter(c => nombresFiltroActividad.has(c.cliente)) : clientes;
  const clienteMap = Object.fromEntries(clientesActividad.map(c => [c.cliente, c]));
  const miembrosAgrupados = new Set(grupos.flatMap(g => g.miembros));

  // Grupos con stats agregados
  const gruposConStats = grupos.map(g => {
    const miembrosData = g.miembros.map(m => clienteMap[m]).filter(Boolean);
    return {
      ...g,
      total_valor:  miembrosData.reduce((s, m) => s + (parseFloat(m.total_valor) || 0), 0),
      registros:    miembrosData.reduce((s, m) => s + (parseInt(m.registros)    || 0), 0),
      pendiente:    miembrosData.reduce((s, m) => s + (parseFloat(m.pendiente)  || 0), 0),
      ultima_fecha: miembrosData.map(m => m.ultima_fecha).filter(Boolean).sort().pop() || null,
      miembrosData,
    };
  });

  const clientesLibres = clientesActividad.filter(c => !miembrosAgrupados.has(c.cliente));

  const q = buscar.toLowerCase().trim();
  const coincideBusqueda = c => {
    if (!q) return true;
    return [c.cliente, c.nit, c.direccion, c.correo, c.miembros].some(v => String(v || '').toLowerCase().includes(q));
  };
  const gruposFiltrados = gruposConStats.filter(g =>
    (!anio || buscaTodos || g.total_valor > 0) &&
    (!q || g.nombre.toLowerCase().includes(q) || g.miembros.some(m => m.toLowerCase().includes(q))));
  const libresFiltrados = clientesLibres.filter(c =>
    (!anio || buscaTodos || (parseFloat(c.total_valor) || 0) > 0) &&
    coincideBusqueda(c));

  function sortItems(arr, keyNombre, keyValor, keyFecha) {
    return [...arr].sort((a, b) => {
      switch (orden) {
        case 'az': return (a[keyNombre]||'').localeCompare(b[keyNombre]||'', 'es');
        case 'za': return (b[keyNombre]||'').localeCompare(a[keyNombre]||'', 'es');
        case 'valor_desc': return (parseFloat(b[keyValor])||0) - (parseFloat(a[keyValor])||0);
        case 'valor_asc':  return (parseFloat(a[keyValor])||0) - (parseFloat(b[keyValor])||0);
        case 'fecha_desc': return (b[keyFecha]||'').localeCompare(a[keyFecha]||'');
        case 'fecha_asc':  return (a[keyFecha]||'').localeCompare(b[keyFecha]||'');
        default: return 0;
      }
    });
  }

  const gruposOrdenados  = sortItems(gruposFiltrados,  'nombre',  'total_valor', 'ultima_fecha');
  const libresOrdenados  = sortItems(libresFiltrados,  'cliente', 'total_valor', 'ultima_fecha');
  const clientesFiltrados = clientesActividad.filter(c =>
    (!anio || (parseInt(c.registros) || 0) > 0 || q) && coincideBusqueda(c));
  const clientesOrdenados = sortItems(clientesFiltrados, 'cliente', 'total_valor', 'ultima_fecha');
  const coincidenciaExacta = q
    ? clientesOrdenados.find(c => [c.cliente, c.nit].some(v => String(v || '').toLowerCase() === q))
    : null;
  const clienteSeleccionado = coincidenciaExacta || clientesOrdenados.find(c => c.cliente === seleccionado) || clientesOrdenados[0] || null;
  const clientesLista = q && clienteSeleccionado
    ? clientesOrdenados.filter(c => c.cliente !== clienteSeleccionado.cliente)
    : clientesOrdenados;
  const totalIngresos = clientesFiltrados.reduce((s, c) => s + (parseFloat(c.total_valor) || 0), 0);
  const totalUtilidad = clientesFiltrados.reduce((s, c) => s + (parseFloat(c.total_utilidad) || 0), 0);
  const totalRegistros = clientesFiltrados.reduce((s, c) => s + (parseInt(c.registros) || 0), 0);
  const clienteFicha = clienteSeleccionado ? {
    ...clienteSeleccionado,
    registros: detalleSeleccionado?.stats?.total ?? clienteSeleccionado.registros,
    total_valor: detalleSeleccionado?.stats?.valor ?? clienteSeleccionado.total_valor,
    total_utilidad: detalleSeleccionado?.stats?.utilidad ?? clienteSeleccionado.total_utilidad,
    pendiente: detalleSeleccionado?.stats?.pendiente ?? clienteSeleccionado.pendiente,
    ultima_fecha: detalleSeleccionado?.stats?.ultima_fecha ?? clienteSeleccionado.ultima_fecha,
  } : null;
  const castigosCliente = clienteCastigos?.items || [];
  const castigadoTotalCliente = clienteCastigos?.total || 0;

  useEffect(() => {
    const nombre = clienteSeleccionado?.cliente;
    if (!nombre) { setDetalleSeleccionado(null); return; }
    setSeleccionado(prev => prev === nombre ? prev : nombre);
    setDetalleSeleccionado(null);
    setCargandoDetalle(true);
    const params = anio && !buscaTodos ? { anio } : {};
    API.get(`/clientes/${encodeURIComponent(nombre)}/detalle`, { params })
      .then(r => setDetalleSeleccionado(r.data))
      .catch(() => setDetalleSeleccionado(null))
      .finally(() => setCargandoDetalle(false));
  }, [clienteSeleccionado?.cliente, anio, buscaTodos]);

  useEffect(() => {
    const nombre = clienteSeleccionado?.cliente;
    if (!nombre) { setClienteCastigos(null); return; }
    API.get(`/clientes/${encodeURIComponent(nombre)}/castigos`)
      .then(r => setClienteCastigos(r.data))
      .catch(() => setClienteCastigos(null));
  }, [clienteSeleccionado?.cliente]);

  // grupos_primero: grupos arriba, libres abajo (default)
  // individuales_primero: libres arriba, grupos abajo
  const bloqueA = orden === 'individuales_primero' ? libresOrdenados  : gruposOrdenados;
  const bloqueB = orden === 'individuales_primero' ? gruposOrdenados  : libresOrdenados;
  const bloqueATipoGrupo = orden !== 'individuales_primero';

  if (vistaCompleta && seleccionado) {
    return (
      <DetalleCliente
        nombre={seleccionado}
        todosLosClientes={clientes}
        onClose={() => setVistaCompleta(false)}
        onRenombrado={() => { setVistaCompleta(false); setSeleccionado(null); cargar(); }}
      />
    );
  }

  function renderGrupo(g) {
    return (
      <div key={g.id} style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
        <div onClick={() => setExpandido(expandido === g.id ? null : g.id)}
          style={{ padding: '12px 16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'background 0.1s' }}
          onMouseEnter={e => e.currentTarget.style.background = '#f9fafb'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 12, color: expandido === g.id ? '#00b8e3' : '#b3b3b3', transition: 'color 0.15s' }}>
              {expandido === g.id ? '▾' : '▸'}
            </span>
            <div>
              {editando?.tipo === 'grupo' && editando.id === g.id ? (
                <form onSubmit={guardarEdicion} onClick={e => e.stopPropagation()} style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                  <input autoFocus value={editNombre} onChange={e => setEditNombre(e.target.value)}
                    style={{ fontSize: 13, fontWeight: 700, color: '#08293f', border: '1px solid #00b8e3', borderRadius: 2, padding: '2px 8px', outline: 'none', background: '#fff', width: 200 }} />
                  <button type="submit" style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: '#00b8e3', border: 'none', borderRadius: 2, padding: '3px 10px', cursor: 'pointer' }}>OK</button>
                  <button type="button" onClick={e => { e.stopPropagation(); setEditando(null); }} style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
                </form>
              ) : (
                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                  <div style={{ fontWeight: 700, color: '#08293f', fontSize: 13 }}>{g.nombre}</div>
                  <button onClick={e => abrirEdicion('grupo', g.id, g.nombre, e)}
                    style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer', padding: '1px 4px', lineHeight: 1 }}
                    title="Renombrar relación">✏</button>
                </div>
              )}
              <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 2 }}>
                {g.registros} registros · {g.miembros.length} clientes · Último: {g.ultima_fecha?.slice(0,10) || '—'}
              </div>
            </div>
          </div>
          <div style={{ textAlign: 'right', display: 'flex', alignItems: 'center', gap: 10 }} onClick={e => e.stopPropagation()}>
            <TecnicoBtn cliente={{ cliente: g.nombre, tecnico_visible: g.tecnico_visible, tecnico_grupo: g.tecnico_grupo }} />
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#08293f' }}>{anio ? fmt(g.total_valor) : '?'}</div>
              {anio && g.pendiente > 0 && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 2 }}>Pendiente: {fmt(g.pendiente)}</div>}
            </div>
          </div>
        </div>
        {expandido === g.id && (
          <div style={{ borderTop: '1px solid #f4f7fa', background: '#f9fafb' }}>
            {g.miembrosData.map(m => {
              const esUnificando = unificando?.cliente === m.cliente;
              const otrosMiembros = g.miembrosData.filter(o => o.cliente !== m.cliente);
              return (
                <div key={m.cliente} style={{ borderBottom: '1px solid #f0f4f8' }}>
                  {esUnificando ? (
                    <div style={{ padding: '10px 16px 10px 40px', background: 'rgba(251,191,36,0.04)', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}
                      onClick={e => e.stopPropagation()}>
                      <span style={{ fontSize: 11, color: '#b45309', fontWeight: 600, whiteSpace: 'nowrap' }}>Renombrar "{m.cliente}" a:</span>
                      <input list={`unif-grp-${m.cliente}`} value={destUnif} onChange={e => setDestUnif(e.target.value)}
                        className="input" style={{ fontSize: 11, padding: '4px 8px', background: '#fff', border: '1px solid #e8eef2', width: 'auto', flex: 1, minWidth: 160 }}
                        placeholder="Buscar miembro..." />
                      <datalist id={`unif-grp-${m.cliente}`}>
                        {otrosMiembros.map(o => <option key={o.cliente} value={o.cliente} />)}
                      </datalist>
                      <button onClick={confirmarUnificacion} disabled={!destUnif}
                        style={{ fontSize: 11, fontWeight: 600, padding: '4px 12px', background: destUnif ? '#b45309' : '#e8eef2', color: destUnif ? '#fff' : '#b3b3b3', border: 'none', cursor: destUnif ? 'pointer' : 'default', borderRadius: 2 }}>
                        Confirmar
                      </button>
                      <button onClick={e => { e.stopPropagation(); setUnificando(null); setDestUnif(''); }}
                        style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>Cancelar</button>
                    </div>
                  ) : editando?.tipo === 'cliente' && editando.nombre === m.cliente ? (
                    <div style={{ padding: '9px 16px 9px 40px', display: 'flex', alignItems: 'center', gap: 8 }}>
                      <form onSubmit={guardarEdicion} onClick={e => e.stopPropagation()} style={{ display: 'flex', gap: 6, alignItems: 'center', flex: 1 }}>
                        <input autoFocus value={editNombre} onChange={e => setEditNombre(e.target.value)}
                          style={{ fontSize: 12, fontWeight: 600, color: '#08293f', border: '1px solid #00b8e3', borderRadius: 2, padding: '2px 8px', outline: 'none', background: '#fff', width: 200 }} />
                        <button type="submit" style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: '#00b8e3', border: 'none', borderRadius: 2, padding: '3px 10px', cursor: 'pointer' }}>OK</button>
                        <button type="button" onClick={e => { e.stopPropagation(); setEditando(null); }} style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
                      </form>
                    </div>
                  ) : (
                    <div onClick={() => setSeleccionado(m.cliente)}
                      style={{ padding: '9px 16px 9px 40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(0,184,227,0.04)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                          <div style={{ fontSize: 12, fontWeight: 600, color: '#08293f' }}>{m.cliente}</div>
                          <button onClick={e => abrirEdicion('cliente', null, m.cliente, e)}
                            style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer', padding: '1px 3px', lineHeight: 1 }}
                            title="Renombrar cliente">✏</button>
                        </div>
                        <div style={{ fontSize: 10, color: '#b3b3b3', marginTop: 1 }}>{m.registros} registros · {m.ultima_fecha?.slice(0,10)}</div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#5a7a8a' }}>{anio ? fmt(m.total_valor) : '—'}</div>
                        {otrosMiembros.length > 0 && (
                          <button onClick={e => { e.stopPropagation(); setUnificando({ cliente: m.cliente }); setDestUnif(''); }}
                            style={{ fontSize: 10, fontWeight: 600, color: '#b45309', background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.25)', padding: '3px 8px', cursor: 'pointer', borderRadius: 2, whiteSpace: 'nowrap' }}>
                            ⇒ Unificar
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {g.miembrosData.length === 0 && <div style={{ padding: '10px 40px', fontSize: 11, color: '#b3b3b3' }}>Sin registros aún</div>}
          </div>
        )}
      </div>
    );
  }

  function renderLibre(c) {
    const esEditando = editando?.tipo === 'cliente' && editando.nombre === c.cliente;
    return (
      <div key={c.cliente}
        style={{ background: '#fff', border: `1px solid ${esEditando ? '#00b8e3' : '#e8eef2'}`, borderRadius: 2, padding: '12px 16px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', transition: 'border-color 0.15s' }}
        onMouseEnter={e => { if (!esEditando) e.currentTarget.style.borderColor = '#00b8e3'; }}
        onMouseLeave={e => { if (!esEditando) e.currentTarget.style.borderColor = '#e8eef2'; }}>
        <div style={{ flex: 1 }}>
          {esEditando ? (
            <form onSubmit={guardarEdicion} style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 2 }}>
              <input autoFocus value={editNombre} onChange={e => setEditNombre(e.target.value)}
                style={{ fontSize: 13, fontWeight: 700, color: '#08293f', border: '1px solid #00b8e3', borderRadius: 2, padding: '2px 8px', outline: 'none', background: '#fff', width: 220 }} />
              <button type="submit" style={{ fontSize: 11, fontWeight: 600, color: '#fff', background: '#00b8e3', border: 'none', borderRadius: 2, padding: '3px 10px', cursor: 'pointer' }}>OK</button>
              <button type="button" onClick={() => setEditando(null)} style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
            </form>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ fontWeight: 700, color: '#08293f', fontSize: 13, cursor: 'pointer' }} onClick={() => setSeleccionado(c.cliente)}>{c.cliente}</div>
              <button onClick={e => abrirEdicion('cliente', null, c.cliente, e)}
                style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer', padding: '1px 4px', lineHeight: 1 }}
                title="Renombrar cliente">✏</button>
            </div>
          )}
          <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 2 }}>{c.registros} registros · Último: {c.ultima_fecha?.slice(0,10)}</div>
        </div>
        <div style={{ textAlign: 'right', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 10 }} onClick={() => !esEditando && setSeleccionado(c.cliente)}>
          <TecnicoBtn cliente={c} />
          <div style={{ fontSize: 14, fontWeight: 700, color: '#08293f' }}>{anio ? fmt(c.total_valor) : '—'}</div>
          {anio && parseFloat(c.pendiente) > 0 && <div style={{ fontSize: 11, color: '#dc2626', marginTop: 2 }}>Pendiente: {fmt(c.pendiente)}</div>}
        </div>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, minmax(0, 1fr))', gap: 8, marginBottom: 12 }} className="clientes-dashboard-grid">
        {[
          { label: 'Atendidos este mes', value: clienteDash.mes_actual, detail: 'Mes en curso', dark: true },
          { label: 'Clientes nuevos', value: clienteDash.nuevos, detail: anio ? `Primer servicio en ${anio}` : 'Primer servicio' },
          { label: 'Recurrentes', value: clienteDash.recurrentes, detail: 'Regresaron este año' },
          { label: 'Reactivados', value: clienteDash.reactivados, detail: 'Tras inactividad +6 meses' },
          { label: 'Total en periodo', value: clientesFiltrados.length, detail: anio ? `Con actividad en ${anio}` : 'Historico completo' },
        ].map((k, i) => (
          <div key={k.label} style={{ background: k.dark ? '#08293f' : '#fff', border: k.dark ? '1px solid rgba(0,184,227,0.22)' : '1px solid #e8eef2', borderRadius: 2, padding: '12px 14px' }}>
            <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: k.dark ? 'rgba(255,255,255,0.62)' : '#7f9aad', marginBottom: 4 }}>{k.label}</div>
            <div style={{ fontSize: 20, lineHeight: 1, fontWeight: 900, color: k.dark ? '#00b8e3' : '#08293f' }}>{k.value}</div>
            <div style={{ fontSize: 11, color: k.dark ? 'rgba(255,255,255,0.68)' : '#5a7a8a', marginTop: 6 }}>{k.detail}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
        <input className="input" placeholder="Buscar cliente, CC/NIT, correo o dirección..." value={buscar} onChange={e => setBuscar(e.target.value)}
          style={{ background: '#f4f7fa', border: '1px solid #e8eef2', flex: '1 1 280px', maxWidth: 420 }} />
        {buscaTodos && (anio || fechaDesde || fechaHasta) && <span style={{ alignSelf: 'center', fontSize: 11, color: '#0087a8', fontWeight: 600 }}>Buscando en todos los años</span>}
        <select value={orden} onChange={e => setOrden(e.target.value)}
          className="input" style={{ background: '#f4f7fa', border: '1px solid #e8eef2', width: 'auto', fontSize: 12 }}>
          {ORDEN_OPTS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
        <select value={anio} onChange={e => setAnio(e.target.value)}
          className="input" style={{ background: '#f4f7fa', border: '1px solid #e8eef2', width: 'auto', fontSize: 12 }}>
          <option value="">Todos los años</option>
          {ANIOS_CLIENTES.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <select value={filtroActividad} onChange={e => setFiltroActividad(e.target.value)}
          className="input" style={{ background: '#f4f7fa', border: '1px solid #e8eef2', width: 'auto', fontSize: 12 }}>
          <option value="todos">Todos los clientes</option>
          <option value="nuevos">Clientes nuevos ({clienteDash.nuevos})</option>
          <option value="reactivados">Clientes reactivados ({clienteDash.reactivados})</option>
          <option value="empresariales">Empresariales ({clientesFijosNombres.size})</option>
        </select>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <input type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)}
            className="input" title="Desde"
            style={{ background: '#f4f7fa', border: `1px solid ${(fechaDesde || fechaHasta) ? '#f59e0b' : '#e8eef2'}`, width: 'auto', fontSize: 12 }} />
          <span style={{ color: '#b3b3b3', fontSize: 12 }}>—</span>
          <input type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)}
            className="input" title="Hasta"
            style={{ background: '#f4f7fa', border: `1px solid ${(fechaDesde || fechaHasta) ? '#f59e0b' : '#e8eef2'}`, width: 'auto', fontSize: 12 }} />
          {(fechaDesde || fechaHasta) && (
            <button onClick={() => { setFechaDesde(''); setFechaHasta(''); }}
              style={{ fontSize: 10, fontWeight: 700, color: '#b45309', background: 'rgba(251,191,36,0.1)', border: '1px solid rgba(251,191,36,0.3)', padding: '4px 8px', cursor: 'pointer', borderRadius: 2 }}>
              x rango
            </button>
          )}
        </div>
      </div>

      {activarTecnico && <ModalPublicarTecnico nombre={activarTecnico.cliente} onClose={() => setActivarTecnico(null)} onGuardado={() => { setActivarTecnico(null); cargar(); }} />}

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(480px, 1.1fr) minmax(360px, 0.9fr)', gap: 12 }} className="clientes-real-layout">
        <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', borderBottom: '1px solid #e8eef2', background: '#f9fafb' }}>
            <div>
              <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Clientes</div>
              <div style={{ fontSize: 12, color: '#b3b3b3', marginTop: 2 }}>Selecciona un cliente para ver su ficha</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: '#00b8e3', background: 'rgba(0,184,227,0.08)', padding: '3px 8px', borderRadius: 2 }}>{clientesLista.length}</span>
              <div style={{ display: 'flex', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
                {[['lista', '≡ Lista'], ['tarjetas', '⊞ Tarjetas']].map(([key, label]) => (
                  <button key={key} onClick={() => setVista(key)}
                    style={{ fontSize: 11, fontWeight: 700, padding: '5px 10px', border: 'none', cursor: 'pointer',
                      background: vista === key ? '#08293f' : '#fff', color: vista === key ? '#00b8e3' : '#5a7a8a' }}>
                    {label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {vista === 'lista' && (
            <div style={{ overflowX: 'auto', maxHeight: 660 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f4f7fa' }}>
                    {['Cliente', 'CC/NIT', 'Servicios', 'Ultimo'].map(h => (
                      <th key={h} style={{ padding: '9px 12px', fontSize: 10, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#5a7a8a', textAlign: h === 'Servicios' ? 'right' : 'left', borderBottom: '1px solid #e8eef2', whiteSpace: 'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clientesLista.map(c => {
                    const sel = c.cliente === clienteSeleccionado?.cliente;
                    const dias = c.ultima_fecha ? Math.floor((Date.now() - new Date(c.ultima_fecha)) / 86400000) : 999;
                    const badge = dias <= 30 ? { label: 'Activo', color: '#059669', bg: 'rgba(5,150,105,0.1)' }
                      : dias <= 90 ? { label: 'Reciente', color: '#b45309', bg: 'rgba(251,191,36,0.1)' } : null;
                    return (
                      <tr key={c.cliente} onClick={() => { setSeleccionado(c.cliente); setVistaCompleta(false); }}
                        style={{ cursor: 'pointer', background: sel ? 'var(--app-selected)' : 'var(--app-surface)', borderBottom: '1px solid var(--app-border)' }}>
                        <td style={{ padding: '10px 12px', minWidth: 180 }}>
                          <div style={{ fontWeight: 800, color: '#08293f', display: 'flex', alignItems: 'center', gap: 5, flexWrap: 'wrap' }}>
                            {c.cliente}
                            {badge && <span style={{ fontSize: 9, fontWeight: 700, background: badge.bg, color: badge.color, padding: '1px 5px', borderRadius: 2 }}>{badge.label}</span>}
                            {clientesFijosNombres.has(c.cliente) && <span style={{ fontSize: 9, fontWeight: 700, background: 'rgba(99,102,241,0.1)', color: '#6366f1', padding: '1px 5px', borderRadius: 2 }}>Empr.</span>}
                            {c.castigado_count > 0 && <span title={`Cartera castigada: ${c.castigado_count} servicio(s)`} style={{ fontSize: 9, fontWeight: 700, background: 'rgba(220,38,38,0.1)', color: '#dc2626', padding: '1px 5px', borderRadius: 2 }}>⚠ Castigado</span>}
                          </div>
                          <div style={{ fontSize: 10, color: '#b3b3b3', marginTop: 2 }}>{c.es_grupo ? `Relacion · ${c.miembros_count || 0} contactos` : (c.correo || c.direccion || '')}</div>
                        </td>
                        <td style={{ padding: '10px 12px', color: c.nit ? '#08293f' : '#b3b3b3', whiteSpace: 'nowrap' }}>{c.nit || '—'}</td>
                        <td style={{ padding: '10px 12px', textAlign: 'right', color: '#5a7a8a' }}>{c.registros}</td>
                        <td style={{ padding: '10px 12px', color: '#5a7a8a', whiteSpace: 'nowrap' }}>{c.ultima_fecha?.slice(0,10) || '—'}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          {vista === 'tarjetas' && (
            <div style={{ padding: 12, display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(190px, 1fr))', gap: 8, maxHeight: 660, overflowY: 'auto' }}>
              {clientesLista.map(c => {
                const sel = c.cliente === clienteSeleccionado?.cliente;
                const dias = c.ultima_fecha ? Math.floor((Date.now() - new Date(c.ultima_fecha)) / 86400000) : 999;
                const badge = dias <= 30 ? { label: 'Activo', color: '#059669', bg: 'rgba(5,150,105,0.1)' }
                  : dias <= 90 ? { label: 'Reciente', color: '#b45309', bg: 'rgba(251,191,36,0.1)' }
                  : { label: 'Inactivo', color: '#b3b3b3', bg: '#f4f7fa' };
                return (
                  <div key={c.cliente}
                    onClick={() => { setSeleccionado(c.cliente); setVistaCompleta(false); }}
                    style={{ background: sel ? 'var(--app-selected)' : 'var(--app-surface)', border: `1px solid ${sel ? '#00b8e3' : 'var(--app-border)'}`, boxShadow: sel ? 'inset 3px 0 0 #00b8e3' : 'none', borderRadius: 4, padding: '12px 14px', cursor: 'pointer', transition: 'background-color 0.15s, border-color 0.15s, box-shadow 0.15s' }}
                    onMouseEnter={e => { if (!sel) e.currentTarget.style.borderColor = '#00b8e3'; }}
                    onMouseLeave={e => { if (!sel) e.currentTarget.style.borderColor = 'var(--app-border)'; }}>
                    <div style={{ fontWeight: 800, color: '#08293f', fontSize: 13, marginBottom: 6, lineHeight: 1.3 }}>{c.cliente}</div>
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 6 }}>
                      <span style={{ fontSize: 9, fontWeight: 700, background: badge.bg, color: badge.color, padding: '2px 6px', borderRadius: 2 }}>{badge.label}</span>
                      {clientesFijosNombres.has(c.cliente) && <span style={{ fontSize: 9, fontWeight: 700, background: 'rgba(99,102,241,0.1)', color: '#6366f1', padding: '2px 6px', borderRadius: 2 }}>Empresarial</span>}
                      {!!c.es_grupo && <span style={{ fontSize: 9, fontWeight: 700, background: 'rgba(0,184,227,0.1)', color: '#00b8e3', padding: '2px 6px', borderRadius: 2 }}>Grupo</span>}
                      {c.castigado_count > 0 && <span title={`Cartera castigada: ${c.castigado_count} servicio(s)`} style={{ fontSize: 9, fontWeight: 700, background: 'rgba(220,38,38,0.1)', color: '#dc2626', padding: '2px 6px', borderRadius: 2 }}>⚠ Castigado</span>}
                    </div>
                    <div style={{ fontSize: 11, color: '#5a7a8a' }}>{c.registros} servicios</div>
                    <div style={{ fontSize: 10, color: '#b3b3b3', marginTop: 2 }}>{c.ultima_fecha?.slice(0,10) || 'Sin actividad'}</div>
                  </div>
                );
              })}
            </div>
          )}

          {clientesLista.length === 0 && (
            <div style={{ textAlign: 'center', padding: '30px 0', color: '#b3b3b3', fontSize: 12 }}>
              {q && clienteSeleccionado ? 'El cliente filtrado se muestra en la ficha' : filtroActividad === 'nuevos' ? 'Sin clientes nuevos para este año' : filtroActividad === 'reactivados' ? 'Sin clientes reactivados para este año' : 'Sin clientes'}
            </div>
          )}
        </div>

        <div style={{ display: 'grid', gap: 12, alignContent: 'start' }}>
          <div style={{ background: '#08293f', border: '1px solid rgba(0,184,227,0.22)', borderRadius: 2, padding: '18px 20px' }}>
            <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(0,184,227,0.75)', marginBottom: 8 }}>— Cliente seleccionado</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'flex-start' }}>
              <div>
                <div style={{ fontSize: 26, lineHeight: 1.05, fontWeight: 900, color: '#fff' }}>{clienteFicha?.cliente || 'Sin cliente'}</div>
                <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.66)', marginTop: 7 }}>
                  {clienteFicha?.nit ? `NIT/CC ${clienteFicha.nit}` : 'CC/NIT pendiente'} · {clienteFicha?.registros || 0} registros · {anio ? anio : 'histórico'}
                </div>
              </div>
              <div style={{ textAlign: 'right', color: '#00b8e3', fontSize: 30, lineHeight: 1, fontWeight: 900 }}>
                {clienteFicha?.total_valor ? `${Math.round((parseFloat(clienteFicha.total_utilidad || 0) / parseFloat(clienteFicha.total_valor || 1)) * 100)}%` : '0%'}
                <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.56)', marginTop: 4, textTransform: 'uppercase', letterSpacing: '0.08em' }}>margen</div>
              </div>
            </div>
          </div>

          {castigosCliente.length > 0 && (
            <div style={{ background: 'rgba(220,38,38,0.08)', border: '1px solid rgba(220,38,38,0.35)', borderRadius: 2, padding: '14px 16px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 15 }}>⚠️</span>
                <div style={{ fontSize: 12, fontWeight: 800, color: '#dc2626' }}>
                  Cartera castigada — {castigosCliente.length} servicio(s) por {fmt(castigadoTotalCliente)}
                </div>
              </div>
              <div style={{ fontSize: 11, color: '#9a3a3a', marginBottom: 10 }}>
                Este cliente dejó de pagar los siguientes servicios y se marcaron como no cobrables. Si vuelve a solicitar algo, esto es lo que debía:
              </div>
              <div style={{ display: 'grid', gap: 6 }}>
                {castigosCliente.map(c => (
                  <div key={c.id} style={{ background: '#fff', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 2, padding: '8px 10px', fontSize: 11 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, fontWeight: 700, color: '#08293f' }}>
                      <span>{c.servicio}</span>
                      <span style={{ color: '#dc2626' }}>{fmt(c.valor)}</span>
                    </div>
                    <div style={{ color: '#5a7a8a', marginTop: 3 }}>
                      Servicio del {c.fecha?.slice(0,10)} · castigado el {c.castigado_fecha?.slice(0,10)} por {c.castigado_usuario || '—'}
                    </div>
                    {c.castigado_motivo && <div style={{ color: '#9a3a3a', marginTop: 3, fontStyle: 'italic' }}>"{c.castigado_motivo}"</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 8 }}>
            {[
              { label: 'Ingresos', value: fmt(clienteFicha?.total_valor), dark: true },
              { label: 'Utilidad', value: fmt(clienteFicha?.total_utilidad), color: '#059669' },
              { label: 'Por cobrar', value: fmt(clienteFicha?.pendiente), color: parseFloat(clienteFicha?.pendiente || 0) > 0 ? '#dc2626' : '#5a7a8a' },
              { label: 'Último movimiento', value: clienteFicha?.ultima_fecha?.slice(0,10) || '—', color: '#08293f' },
            ].map(k => (
              <div key={k.label} style={{ background: k.dark ? '#08293f' : '#fff', border: k.dark ? '1px solid rgba(0,184,227,0.22)' : '1px solid #e8eef2', borderRadius: 2, padding: '12px 14px' }}>
                <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: k.dark ? 'rgba(0,184,227,0.65)' : '#5a7a8a', marginBottom: 5 }}>{k.label}</div>
                <div style={{ fontSize: 16, fontWeight: 800, color: k.dark ? '#00b8e3' : k.color }}>{k.value}</div>
              </div>
            ))}
          </div>

          <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '14px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, gap: 8 }}>
              <div>
                <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Datos del cliente</div>
                <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>Información legal y de contacto</div>
              </div>
              {clienteSeleccionado && (
                <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                  <TecnicoBtn cliente={clienteSeleccionado} />
                  <button onClick={() => setVistaCompleta(true)} className="btn-primary" style={{ padding: '6px 12px', fontSize: 12 }}>Ver ficha completa</button>
                </div>
              )}
            </div>
            <div style={{ display: 'grid', borderTop: '1px solid var(--app-border)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, borderBottom: '1px solid var(--app-border)', padding: '9px 10px' }}><span style={{ color: '#5a7a8a', fontSize: 12 }}>CC/NIT</span><b>{clienteSeleccionado?.nit || 'Pendiente'}</b></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, borderBottom: '1px solid var(--app-border)', padding: '9px 10px' }}><span style={{ color: '#5a7a8a', fontSize: 12 }}>Correo</span><b>{clienteSeleccionado?.correo || 'Pendiente'}</b></div>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, borderBottom: '1px solid var(--app-border)', padding: '9px 10px' }}>
                <span style={{ color: '#5a7a8a', fontSize: 12 }}>Dirección</span>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <b style={{ textAlign: 'right' }}>{clienteSeleccionado?.direccion || 'Pendiente'}</b>
                  {clienteSeleccionado?.direccion && (
                    <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(clienteSeleccionado.direccion + ', Medellín, Colombia')}`}
                      target="_blank" rel="noopener noreferrer"
                      style={{ fontSize: 10, color: '#00b8e3', fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap' }}>📍</a>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
            <div onClick={() => setExpandServicios(v => !v)}
              style={{ display: 'flex', justifyContent: 'space-between', gap: 10, alignItems: 'center', padding: '12px 16px', cursor: 'pointer', borderBottom: expandServicios ? '1px solid #f4f7fa' : 'none' }}>
              <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>
                — Servicios {fechaDesde || fechaHasta ? `${fechaDesde || '?'} → ${fechaHasta || '?'}` : anio ? `de ${anio}` : 'de todos los años'}
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ fontSize: 10, fontWeight: 800, color: '#00b8e3' }}>{detalleSeleccionado?.registros?.length || 0} registros</span>
                <span style={{ fontSize: 12, color: '#b3b3b3' }}>{expandServicios ? '▲' : '▼'}</span>
              </div>
            </div>
            {cargandoDetalle && expandServicios && <div style={{ padding: '20px 16px', color: '#b3b3b3', fontSize: 12 }}>Cargando...</div>}
            {!cargandoDetalle && expandServicios && (
              <div style={{ maxHeight: 460, overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                  <thead>
                    <tr style={{ background: '#f4f7fa' }}>
                      {['Fecha', 'Servicio', 'Valor', 'Estado'].map(h => (
                        <th key={h} style={{ padding: '7px 12px', fontSize: 10, fontWeight: 800, letterSpacing: '0.06em', textTransform: 'uppercase', color: '#5a7a8a', textAlign: h === 'Valor' ? 'right' : 'left', borderBottom: '1px solid #e8eef2', whiteSpace: 'nowrap' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {detalleSeleccionado?.registros?.map(r => (
                      <tr key={r.id} style={{ borderBottom: '1px solid #f4f7fa' }}>
                        <td style={{ padding: '8px 12px', color: '#5a7a8a', whiteSpace: 'nowrap' }}>{r.fecha?.slice(0,10)}</td>
                        <td style={{ padding: '8px 12px', color: '#08293f', fontWeight: 600 }}>
                          {r.servicio_organizado || r.servicio || '—'}
                          <button onClick={() => abrirEditarRegistro(r)} style={{ marginLeft: 6, fontSize: 10, fontWeight: 700, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>✎</button>
                        </td>
                        <td style={{ padding: '8px 12px', textAlign: 'right', fontWeight: 700, color: '#08293f', whiteSpace: 'nowrap' }}>{fmt(r.valor)}</td>
                        <td style={{ padding: '8px 12px' }}><Tag text={r.estado} /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            {!cargandoDetalle && expandServicios && (!detalleSeleccionado?.registros || detalleSeleccionado.registros.length === 0) && (
              <div style={{ padding: '20px 16px', color: '#b3b3b3', fontSize: 12 }}>Sin registros en el periodo</div>
            )}
          </div>
        </div>
      </div>
      {registroEditando && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 460 }}>
            <div style={{ padding: 22 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, marginBottom: 16 }}>
                <div>
                  <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a', marginBottom: 6 }}>— Editar registro individual</div>
                  <div style={{ fontSize: 16, fontWeight: 900, color: '#08293f' }}>{registroEditando.servicio || 'Servicio'}</div>
                  <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 3 }}>{String(registroEditando.fecha || '').slice(0, 10)} · {fmt(registroEditando.valor)}</div>
                </div>
                <button onClick={() => setRegistroEditando(null)} style={{ fontSize: 22, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer', lineHeight: 1 }}>×</button>
              </div>
              <form onSubmit={guardarRegistroIndividual}>
                <label className="label">Cliente correcto para este registro</label>
                <input
                  className="input"
                  list="clientes-registro-edit-list"
                  value={registroCliente}
                  onChange={e => setRegistroCliente(e.target.value)}
                  style={{ background: '#f9fafb', border: '1px solid #e8eef2', marginBottom: 10 }}
                  autoFocus
                />
                <datalist id="clientes-registro-edit-list">
                  {clientes.map(c => <option key={c.cliente} value={c.cliente} />)}
                </datalist>
                <div style={{ fontSize: 11, color: '#5a7a8a', lineHeight: 1.45, marginBottom: 14 }}>
                  Esto mueve solo este registro. No renombra el cliente ni cambia los demás servicios.
                </div>
                {registroMsg && <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', marginBottom: 12 }}>{registroMsg}</div>}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="submit" disabled={guardandoRegistro || !registroCliente.trim()} className="btn-primary" style={{ padding: '8px 14px', fontSize: 12, opacity: guardandoRegistro ? 0.7 : 1 }}>
                    {guardandoRegistro ? 'Guardando...' : 'Guardar registro'}
                  </button>
                  <button type="button" onClick={() => setRegistroEditando(null)} className="btn-secondary" style={{ padding: '8px 14px', fontSize: 12 }}>Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Tab Clientes Empresariales ────────────────────────────────────
function TabFijos() {
  const [fijos,    setFijos]    = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId,   setEditId]   = useState(null);
  const [form,     setForm]     = useState({ cliente: '', servicio: '', valor: '', costo: '', proveedor: '' });
  const inp = { background: '#f4f7fa', border: '1px solid #e8eef2' };

  const cargar = useCallback(() => {
    API.get('/clientes-fijos').then(r => setFijos(Array.isArray(r.data) ? r.data : []));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const ingresos = fijos.reduce((s, f) => s + (parseFloat(f.valor) || 0), 0);
  const costos   = fijos.reduce((s, f) => s + (parseFloat(f.costo) || 0), 0);

  async function guardar(e) {
    e.preventDefault();
    if (editId) await API.put(`/clientes-fijos/${editId}`, form);
    else        await API.post('/clientes-fijos', form);
    setShowForm(false); setEditId(null); cargar();
  }

  function editar(f) {
    setForm({ cliente: f.cliente, servicio: f.servicio || '', valor: f.valor, costo: f.costo || '', proveedor: f.proveedor || '' });
    setEditId(f.id); setShowForm(true);
  }

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 8, marginBottom: 16 }}>
        {[
          { label: 'Ingresos empresariales', value: fmt(ingresos), dark: true },
          { label: 'Utilidad',       value: fmt(ingresos - costos), color: '#059669' },
          { label: 'Costo',          value: fmt(costos),            color: '#dc2626' },
        ].map((k, i) => (
          <div key={i} style={{ background: k.dark ? '#08293f' : '#fff', border: k.dark ? '1px solid rgba(0,184,227,0.2)' : '1px solid #e8eef2', padding: '12px 14px', borderRadius: 2 }}>
            <div style={{ fontSize: 9, fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: k.dark ? 'rgba(0,184,227,0.6)' : '#5a7a8a', marginBottom: 3 }}>{k.label}</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: k.dark ? '#00b8e3' : k.color }}>{k.value}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
        <button className="btn-primary" onClick={() => { setForm({ cliente:'', servicio:'', valor:'', costo:'', proveedor:'' }); setEditId(null); setShowForm(true); }}>+ Agregar</button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {fijos.map(f => (
          <div key={f.id} style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
            <div>
              <div style={{ fontWeight: 700, color: '#08293f', fontSize: 13 }}>{f.cliente}</div>
              <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 2 }}>{f.servicio || '—'}</div>
            </div>
            <div style={{ display: 'flex', gap: 16, alignItems: 'center' }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ fontSize: 13, fontWeight: 700 }}>{fmt(f.valor)}</div>
                <div style={{ fontSize: 11, color: '#059669' }}>Util: {fmt((parseFloat(f.valor)||0) - (parseFloat(f.costo)||0))}</div>
              </div>
              <button onClick={() => editar(f)} style={{ fontSize: 11, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer' }}>Editar</button>
            </div>
          </div>
        ))}
        {fijos.length === 0 && <div style={{ color: '#5a7a8a', textAlign: 'center', padding: 32, fontSize: 13 }}>Sin clientes empresariales registrados</div>}
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 440 }}>
            <div style={{ padding: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h2 style={{ fontSize: 13, fontWeight: 700, color: '#08293f', margin: 0, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  {editId ? 'Editar cliente empresarial' : 'Nuevo cliente empresarial'}
                </h2>
                <button onClick={() => setShowForm(false)} style={{ fontSize: 20, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
              </div>
              <form onSubmit={guardar}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label className="label">Cliente *</label>
                    <input className="input" value={form.cliente} style={inp} required onChange={e => setForm(f => ({ ...f, cliente: e.target.value }))} />
                  </div>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label className="label">Servicio</label>
                    <input className="input" value={form.servicio} style={inp} onChange={e => setForm(f => ({ ...f, servicio: e.target.value }))} />
                  </div>
                  <div>
                    <label className="label">Valor *</label>
                    <input className="input" type="number" value={form.valor} style={inp} required min="0" onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} />
                  </div>
                  <div>
                    <label className="label">Costo</label>
                    <input className="input" type="number" value={form.costo} style={inp} min="0" onChange={e => setForm(f => ({ ...f, costo: e.target.value }))} />
                  </div>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label className="label">Proveedor</label>
                    <input className="input" value={form.proveedor} style={inp} onChange={e => setForm(f => ({ ...f, proveedor: e.target.value }))} />
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="submit" className="btn-primary" style={{ flex: 1, padding: 9 }}>Guardar</button>
                  <button type="button" className="btn-secondary" onClick={() => setShowForm(false)}>Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ── Cluster card con checkboxes individuales ──────────────────────
function ClusterCard({ cluster, onCrear, onDescartar }) {
  const [sel, setSel] = useState(new Set());
  const toggle = c => setSel(s => { const n = new Set(s); n.has(c) ? n.delete(c) : n.add(c); return n; });
  const activos = cluster.filter(c => sel.has(c));
  return (
    <div style={{ padding: '10px 12px', background: '#fff', borderRadius: 2, border: '1px solid #e8eef2' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 3, marginBottom: 8 }}>
        {cluster.map(c => (
          <label key={c} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', padding: '4px 6px', borderRadius: 2, background: sel.has(c) ? 'rgba(0,184,227,0.06)' : 'transparent', border: `1px solid ${sel.has(c) ? 'rgba(0,184,227,0.15)' : 'transparent'}` }}>
            <input type="checkbox" checked={sel.has(c)} onChange={() => toggle(c)} style={{ accentColor: '#00b8e3' }} />
            <span style={{ fontSize: 12, fontWeight: 600, color: '#08293f' }}>{c}</span>
          </label>
        ))}
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        <button onClick={() => activos.length >= 1 && onCrear(activos)} disabled={activos.length < 1}
          style={{ fontSize: 11, fontWeight: 600, color: '#00b8e3', background: 'rgba(0,184,227,0.08)', border: '1px solid rgba(0,184,227,0.2)', padding: '4px 12px', cursor: activos.length < 1 ? 'default' : 'pointer', borderRadius: 2, opacity: activos.length < 1 ? 0.4 : 1 }}>
          Crear empresa / contacto ({activos.length})
        </button>
        <button onClick={() => onDescartar(cluster)}
          style={{ fontSize: 11, fontWeight: 600, color: '#5a7a8a', background: '#f4f7fa', border: '1px solid #e8eef2', padding: '4px 12px', cursor: 'pointer', borderRadius: 2 }}>
          No son la misma empresa
        </button>
      </div>
    </div>
  );
}

// ── Tab Organizar Contactos ───────────────────────────────────────
export function TabGrupos() {
  const [grupos,      setGrupos]      = useState([]);
  const [sugeridos,   setSugeridos]   = useState([]);
  const [clientes,    setClientes]    = useState([]);
  const [selec,       setSelec]       = useState(new Set());
  const [buscar,      setBuscar]      = useState('');
  const [showForm,    setShowForm]    = useState(false);
  const [editGrupo,   setEditGrupo]   = useState(null);
  const [form,        setForm]        = useState({ nombre: '', nit: '', notas: '' });
  const [loadingSug,  setLoadingSug]  = useState(false);
  const [grupoDestino, setGrupoDestino] = useState('');
  const inp = { background: '#f4f7fa', border: '1px solid #e8eef2' };

  const cargar = useCallback(async () => {
    const [g, c] = await Promise.all([API.get('/clientes/grupos'), API.get('/clientes')]);
    setGrupos(g.data); setClientes(c.data);
  }, []);

  const cargarSugeridos = useCallback(async () => {
    setLoadingSug(true);
    try { const r = await API.get('/clientes/sugeridos'); setSugeridos(r.data); }
    catch { setSugeridos([]); }
    finally { setLoadingSug(false); }
  }, []);

  useEffect(() => { cargar(); cargarSugeridos(); }, [cargar, cargarSugeridos]);

  const yaAgrupados = new Set(grupos.flatMap(g => g.miembros));
  const libres = clientes
    .filter(c => !yaAgrupados.has(c.cliente))
    .filter(c => !buscar || c.cliente.toLowerCase().includes(buscar.toLowerCase()));

  function toggleSelec(nombre) {
    setSelec(s => { const n = new Set(s); n.has(nombre) ? n.delete(nombre) : n.add(nombre); return n; });
  }

  function prefixComun(arr) {
    if (!arr.length) return '';
    let p = arr[0];
    for (const s of arr.slice(1)) { while (p && !s.startsWith(p)) p = p.slice(0, -1); }
    return p.trim().replace(/[-_\s]+$/, '') || arr[0];
  }

  function abrirCrear(preselec = [], nombre = '') {
    setEditGrupo(null);
    setForm({ nombre, nit: '', notas: '' });
    setSelec(new Set(preselec));
    setShowForm(true);
  }

  async function descartarCluster(clientes) {
    await API.post('/clientes/sugeridos/descartar', { clientes });
    cargarSugeridos();
  }

  async function agregarAGrupoExistente() {
    if (!grupoDestino || !selec.size) return;
    for (const cliente of selec)
      await API.post(`/clientes/grupos/${grupoDestino}/miembros`, { cliente });
    setSelec(new Set()); setGrupoDestino(''); cargar(); cargarSugeridos();
  }

  function abrirEditar(g) {
    setEditGrupo(g);
    setForm({ nombre: g.nombre, nit: g.nit || '', notas: g.notas || '' });
    setSelec(new Set(g.miembros));
    setShowForm(true);
  }

  async function guardar(e) {
    e.preventDefault();
    const miembros = [...selec];
    if (editGrupo) {
      await API.put(`/clientes/grupos/${editGrupo.id}`, form);
      const antes = new Set(editGrupo.miembros);
      const despues = new Set(miembros);
      for (const c of despues) if (!antes.has(c)) await API.post(`/clientes/grupos/${editGrupo.id}/miembros`, { cliente: c });
      for (const c of antes) if (!despues.has(c)) await API.delete(`/clientes/grupos/${editGrupo.id}/miembros`, { data: { cliente: c } });
    } else {
      await API.post('/clientes/grupos', { ...form, miembros });
    }
    setShowForm(false); setSelec(new Set()); cargar(); cargarSugeridos();
  }

  async function eliminarGrupo(id) {
    if (!window.confirm('¿Eliminar esta relación? Los clientes quedarán sin organizar.')) return;
    await API.delete(`/clientes/grupos/${id}`); cargar(); cargarSugeridos();
  }

  const seleccionados = [...selec];
  const sugerenciaActiva = sugeridos[0]
    ? (Array.isArray(sugeridos[0]) ? sugeridos[0] : (sugeridos[0].clientes || []))
    : [];
  const registrosSeleccionados = seleccionados.reduce((s, nombre) => {
    const c = clientes.find(x => x.cliente === nombre);
    return s + (parseInt(c?.registros) || 0);
  }, 0);
  const impactoSeleccionado = seleccionados.reduce((s, nombre) => {
    const c = clientes.find(x => x.cliente === nombre);
    return s + (parseFloat(c?.total_valor) || 0);
  }, 0);

  if (Array.isArray(grupos)) return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 8, marginBottom: 14 }} className="clientes-dashboard-grid">
        {[
          { label: 'Relaciones actuales', value: grupos.length, detail: 'Empresas/contactos organizados', dark: true },
          { label: 'Sugerencias', value: loadingSug ? '...' : sugeridos.length, detail: 'Coincidencias pendientes' },
          { label: 'Sin organizar', value: libres.length, detail: 'Clientes sueltos' },
          { label: 'Seleccionados', value: selec.size, detail: `${registrosSeleccionados} registros · ${fmt(impactoSeleccionado)}` },
        ].map((k, i) => (
          <div key={k.label} style={{ background: k.dark ? '#08293f' : '#fff', border: k.dark ? '1px solid rgba(0,184,227,0.22)' : '1px solid #e8eef2', borderRadius: 2, padding: '12px 14px' }}>
            <div style={{ fontSize: 9, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: k.dark ? 'rgba(255,255,255,0.62)' : '#7f9aad', marginBottom: 4 }}>{k.label}</div>
            <div style={{ fontSize: 20, lineHeight: 1, fontWeight: 900, color: k.dark ? '#00b8e3' : i === 1 ? '#b45309' : '#08293f' }}>{k.value}</div>
            <div style={{ fontSize: 11, color: k.dark ? 'rgba(255,255,255,0.68)' : '#5a7a8a', marginTop: 6 }}>{k.detail}</div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(360px, 0.95fr) minmax(420px, 1.05fr)', gap: 12 }} className="clientes-real-layout">
        <div style={{ display: 'grid', gap: 12, alignContent: 'start' }}>
          <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e8eef2' }}>
              <div>
                <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Casos claros</div>
                <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>Solo coincidencias pequeñas y de alta confianza</div>
              </div>
              <button onClick={cargarSugeridos} className="btn-secondary" style={{ fontSize: 11, padding: '5px 10px' }}>{loadingSug ? 'Analizando...' : 'Actualizar'}</button>
            </div>
            {loadingSug && <div style={{ padding: '20px 16px', color: '#b3b3b3', fontSize: 12 }}>Analizando coincidencias...</div>}
            {!loadingSug && sugeridos.length === 0 && <div style={{ padding: '20px 16px', color: '#b3b3b3', fontSize: 12 }}>Sin sugerencias pendientes</div>}
            {!loadingSug && sugeridos.slice(0, 8).map((cluster, i) => {
              const nombres = Array.isArray(cluster) ? cluster : (cluster.clientes || []);
              const clusterRegs = cluster.registros ?? nombres.reduce((s, nombre) => s + (parseInt(clientes.find(c => c.cliente === nombre)?.registros) || 0), 0);
              const score = cluster.score ?? Math.max(70, 94 - i * 3);
              return (
                <div key={i} style={{ display: 'grid', gridTemplateColumns: '58px 1fr auto', gap: 10, alignItems: 'center', padding: '12px 14px', borderTop: '1px solid #f4f7fa' }}>
                  <div style={{ width: 48, height: 48, display: 'grid', placeItems: 'center', background: score >= 90 ? 'rgba(5,150,105,0.08)' : 'rgba(251,191,36,0.1)', color: score >= 90 ? '#059669' : '#b45309', border: `1px solid ${score >= 90 ? 'rgba(5,150,105,0.22)' : 'rgba(251,191,36,0.25)'}`, fontSize: 13, fontWeight: 900 }}>{score}%</div>
                  <div>
                    <div style={{ fontSize: 12, fontWeight: 800, color: '#08293f' }}>{nombres.join(' / ')}</div>
                    <div style={{ fontSize: 11, color: '#5a7a8a', marginTop: 3 }}>{nombres.length} nombres · {clusterRegs} registros · {fmt(cluster.total_valor || 0)} impacto</div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                    <button onClick={() => abrirCrear(nombres, prefixComun(nombres))} style={{ fontSize: 11, fontWeight: 700, color: '#00b8e3', background: 'rgba(0,184,227,0.08)', border: '1px solid rgba(0,184,227,0.2)', padding: '5px 10px', cursor: 'pointer', borderRadius: 2 }}>Revisar</button>
                    <button onClick={() => descartarCluster(nombres)} style={{ fontSize: 11, fontWeight: 700, color: '#5a7a8a', background: '#f4f7fa', border: '1px solid #e8eef2', padding: '5px 10px', cursor: 'pointer', borderRadius: 2 }}>Descartar</button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e8eef2' }}>
              <div>
                <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Buscador manual</div>
                <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>Busca como hicimos con Medianero y decide qué entra</div>
              </div>
              <input className="input" style={{ ...inp, fontSize: 12, padding: '5px 10px', width: 210 }} placeholder="Buscar..." value={buscar} onChange={e => setBuscar(e.target.value)} />
            </div>
            <div style={{ maxHeight: 360, overflowY: 'auto', display: 'grid', gap: 3, padding: 10 }}>
              {libres.map(c => (
                <label key={c.cliente} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '7px 10px', background: selec.has(c.cliente) ? 'rgba(0,184,227,0.06)' : '#f9fafb', borderRadius: 2, cursor: 'pointer', border: `1px solid ${selec.has(c.cliente) ? 'rgba(0,184,227,0.2)' : 'transparent'}` }}>
                  <input type="checkbox" checked={selec.has(c.cliente)} onChange={() => toggleSelec(c.cliente)} style={{ accentColor: '#00b8e3' }} />
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#08293f', flex: 1 }}>{c.cliente}</span>
                  <span style={{ fontSize: 11, color: '#b3b3b3' }}>{c.registros} reg.</span>
                  <span style={{ fontSize: 11, fontWeight: 700, color: '#059669' }}>{fmt(c.total_valor)}</span>
                </label>
              ))}
              {libres.length === 0 && <div style={{ fontSize: 12, color: '#b3b3b3', textAlign: 'center', padding: '16px 0' }}>Todos los clientes están organizados</div>}
            </div>
          </div>
        </div>

        <div style={{ display: 'grid', gap: 12, alignContent: 'start' }}>
          <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{ padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e8eef2' }}>
              <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Mesa de decisión</div>
              <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>Previsualiza cómo quedaría antes de guardar</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 60px 1fr', gap: 12, padding: 14, alignItems: 'stretch' }} className="clientes-real-layout">
              <div style={{ border: '1px solid #e8eef2', background: '#fbfdff', padding: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#08293f', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 10 }}>Nombres origen</div>
                <div style={{ display: 'grid', gap: 7 }}>
                  {(seleccionados.length ? seleccionados : sugerenciaActiva).slice(0, 8).map(nombre => (
                    <div key={nombre} style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center', border: '1px solid #e8eef2', background: '#fff', padding: '8px 9px', fontSize: 12, fontWeight: 800 }}>
                      <span>{nombre}</span>
                      <span style={{ color: '#b3b3b3' }}>{clientes.find(c => c.cliente === nombre)?.registros || 0}</span>
                    </div>
                  ))}
                  {!seleccionados.length && !sugerenciaActiva.length && <div style={{ color: '#b3b3b3', fontSize: 12 }}>Selecciona clientes o usa una sugerencia.</div>}
                </div>
              </div>
              <div style={{ display: 'grid', placeItems: 'center', color: '#00b8e3', fontSize: 32, fontWeight: 900 }}>→</div>
              <div style={{ border: '1px solid #e8eef2', background: '#fbfdff', padding: 12 }}>
                <div style={{ fontSize: 11, fontWeight: 800, color: '#08293f', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 10 }}>Resultado</div>
                <div style={{ display: 'grid', gap: 8 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, border: '1px solid #e8eef2', background: '#fff', padding: '8px 9px', fontSize: 12 }}><b>Relación</b><span>{form.nombre || prefixComun(seleccionados.length ? seleccionados : sugerenciaActiva) || 'Pendiente'}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, border: '1px solid #e8eef2', background: '#fff', padding: '8px 9px', fontSize: 12 }}><b>NIT/CC</b><span>{form.nit || 'Pendiente'}</span></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, border: '1px solid #e8eef2', background: '#fff', padding: '8px 9px', fontSize: 12 }}><b>Notas</b><span>{form.notas || 'Detalles, solicitantes o equipos'}</span></div>
                  <button onClick={() => abrirCrear(seleccionados.length ? seleccionados : sugerenciaActiva, prefixComun(seleccionados.length ? seleccionados : sugerenciaActiva))} disabled={!seleccionados.length && !sugerenciaActiva.length} className="btn-primary" style={{ padding: '8px 12px', fontSize: 12, opacity: (!seleccionados.length && !sugerenciaActiva.length) ? 0.5 : 1 }}>Crear / editar relación</button>
                </div>
              </div>
            </div>
            {selec.size > 0 && (
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', padding: '12px 14px', borderTop: '1px solid #e8eef2', background: '#f9fafb' }}>
                <button onClick={() => abrirCrear(seleccionados)} className="btn-primary" style={{ fontSize: 12, padding: '6px 14px' }}>+ Crear relación ({selec.size})</button>
                {grupos.length > 0 && (
                  <>
                    <select value={grupoDestino} onChange={e => setGrupoDestino(e.target.value)} className="input" style={{ ...inp, fontSize: 12, padding: '6px 10px', width: 'auto' }}>
                      <option value="">Agregar a relación existente...</option>
                      {grupos.map(g => <option key={g.id} value={g.id}>{g.nombre}{g.nit ? ` · ${g.nit}` : ''}</option>)}
                    </select>
                    {grupoDestino && <button onClick={agregarAGrupoExistente} className="btn-primary" style={{ fontSize: 12, padding: '6px 14px', background: '#059669', borderColor: '#059669' }}>Agregar</button>}
                  </>
                )}
                <button onClick={() => { setSelec(new Set()); setGrupoDestino(''); }} style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>Limpiar</button>
              </div>
            )}
          </div>

          <div style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '12px 16px', background: '#f9fafb', borderBottom: '1px solid #e8eef2' }}>
              <div>
                <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Relaciones existentes</div>
                <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>Equivale a los grupos actuales, con mejor lectura</div>
              </div>
              <button onClick={() => abrirCrear()} className="btn-primary" style={{ fontSize: 12, padding: '5px 14px' }}>+ Nueva relación</button>
            </div>
            <div style={{ display: 'grid', gap: 8, padding: 12, maxHeight: 440, overflowY: 'auto' }}>
              {grupos.map(g => (
                <div key={g.id} style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '12px 14px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 8 }}>
                    <div>
                      <span style={{ fontWeight: 800, color: '#08293f', fontSize: 14 }}>{g.nombre}</span>
                      {g.nit && <span style={{ fontSize: 11, color: '#5a7a8a', marginLeft: 10, background: '#f4f7fa', padding: '2px 8px', borderRadius: 2 }}>NIT {g.nit}</span>}
                      {g.notas && <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>{g.notas}</div>}
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => abrirEditar(g)} style={{ fontSize: 11, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer' }}>Editar</button>
                      <button onClick={() => eliminarGrupo(g.id)} style={{ fontSize: 11, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer' }}>Eliminar</button>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                    {g.miembros.map(m => <span key={m} style={{ fontSize: 11, background: 'rgba(0,184,227,0.08)', color: '#0087a8', padding: '3px 10px', borderRadius: 10, border: '1px solid rgba(0,184,227,0.15)' }}>{m}</span>)}
                    {g.miembros.length === 0 && <span style={{ fontSize: 11, color: '#b3b3b3' }}>Sin miembros</span>}
                  </div>
                </div>
              ))}
              {grupos.length === 0 && <div style={{ textAlign: 'center', padding: '30px 0', color: '#b3b3b3', fontSize: 12 }}>Sin relaciones creadas</div>}
            </div>
          </div>
        </div>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 560 }}>
            <div style={{ padding: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h2 style={{ fontSize: 13, fontWeight: 800, color: '#08293f', margin: 0, textTransform: 'uppercase', letterSpacing: '0.04em' }}>{editGrupo ? 'Editar relación de contactos' : 'Nueva relación de contactos'}</h2>
                <button onClick={() => { setShowForm(false); setSelec(new Set()); }} style={{ fontSize: 20, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
              </div>
              <form onSubmit={guardar}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div style={{ gridColumn: '1/-1' }}><label className="label">Nombre / empresa *</label><input className="input" value={form.nombre} style={inp} required onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} /></div>
                  <div><label className="label">NIT / CC</label><input className="input" value={form.nit} style={inp} placeholder="Documento legal" onChange={e => setForm(f => ({ ...f, nit: e.target.value }))} /></div>
                  <div><label className="label">Notas</label><input className="input" value={form.notas} style={inp} placeholder="Torre, Lenovo, solicitantes..." onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} /></div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label className="label">Clientes / nombres asociados ({selec.size})</label>
                  <div style={{ maxHeight: 220, overflowY: 'auto', border: '1px solid #e8eef2', borderRadius: 2, padding: 8, background: '#f9fafb' }}>
                    {clientes.map(c => (
                      <label key={c.cliente} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 6px', cursor: 'pointer', borderRadius: 2, background: selec.has(c.cliente) ? 'rgba(0,184,227,0.06)' : 'transparent' }}>
                        <input type="checkbox" checked={selec.has(c.cliente)} onChange={() => toggleSelec(c.cliente)} style={{ accentColor: '#00b8e3' }} />
                        <span style={{ fontSize: 12, color: '#08293f', flex: 1 }}>{c.cliente}</span>
                        {yaAgrupados.has(c.cliente) && !selec.has(c.cliente) && <span style={{ fontSize: 10, color: '#b45309' }}>en otra relación</span>}
                      </label>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="submit" className="btn-primary" style={{ flex: 1, padding: 9 }}>Guardar relación</button>
                  <button type="button" className="btn-secondary" onClick={() => { setShowForm(false); setSelec(new Set()); }}>Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  return (
    <div>
      {/* Sugeridos con checkboxes por cluster */}
      {(sugeridos.length > 0 || loadingSug) && (
        <div style={{ background: 'rgba(0,184,227,0.04)', border: '1px solid rgba(0,184,227,0.15)', borderRadius: 2, padding: '14px 16px', marginBottom: 20 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#00b8e3', marginBottom: 10 }}>
            — Posibles mismas empresas detectadas
          </div>
          {loadingSug
            ? <div style={{ fontSize: 12, color: '#b3b3b3' }}>Analizando...</div>
            : <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {sugeridos.map((cluster, i) => (
                  <ClusterCard key={i} cluster={cluster}
                    onCrear={sel => abrirCrear(sel, prefixComun(sel))}
                    onDescartar={descartarCluster} />
                ))}
              </div>
          }
        </div>
      )}

      {/* Buscador + clientes sin agrupar */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10, flexWrap: 'wrap', gap: 8 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>
            — Clientes sin agrupar
            {selec.size > 0 && <span style={{ marginLeft: 8, color: '#00b8e3' }}>{selec.size} seleccionados</span>}
          </div>
          <input className="input" style={{ ...inp, fontSize: 12, padding: '5px 10px', width: 200 }} placeholder="Buscar cliente..." value={buscar} onChange={e => setBuscar(e.target.value)} />
        </div>

        <div style={{ maxHeight: 260, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 3, marginBottom: selec.size > 0 ? 10 : 0 }}>
          {libres.map(c => (
            <label key={c.cliente} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 10px', background: selec.has(c.cliente) ? 'rgba(0,184,227,0.06)' : '#f9fafb', borderRadius: 2, cursor: 'pointer', border: `1px solid ${selec.has(c.cliente) ? 'rgba(0,184,227,0.2)' : 'transparent'}` }}>
              <input type="checkbox" checked={selec.has(c.cliente)} onChange={() => toggleSelec(c.cliente)} style={{ accentColor: '#00b8e3' }} />
              <span style={{ fontSize: 12, fontWeight: 600, color: '#08293f', flex: 1 }}>{c.cliente}</span>
              <span style={{ fontSize: 11, color: '#b3b3b3' }}>{c.registros} reg.</span>
            </label>
          ))}
          {libres.length === 0 && <div style={{ fontSize: 12, color: '#b3b3b3', textAlign: 'center', padding: '16px 0' }}>Todos los clientes están agrupados</div>}
        </div>

        {/* Acciones cuando hay selección */}
        {selec.size > 0 && (
          <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', paddingTop: 10, borderTop: '1px solid #e8eef2' }}>
            <button onClick={() => abrirCrear([...selec])} className="btn-primary" style={{ fontSize: 12, padding: '6px 14px' }}>
              + Crear nueva relación ({selec.size})
            </button>
            {grupos.length > 0 && (
              <>
                <select value={grupoDestino} onChange={e => setGrupoDestino(e.target.value)}
                  className="input" style={{ ...inp, fontSize: 12, padding: '6px 10px', width: 'auto' }}>
                  <option value="">Agregar a relación existente...</option>
                  {grupos.map(g => <option key={g.id} value={g.id}>{g.nombre}{g.nit ? ` · ${g.nit}` : ''}</option>)}
                </select>
                {grupoDestino && (
                  <button onClick={agregarAGrupoExistente} className="btn-primary" style={{ fontSize: 12, padding: '6px 14px', background: '#059669', borderColor: '#059669' }}>
                    Agregar
                  </button>
                )}
              </>
            )}
            <button onClick={() => { setSelec(new Set()); setGrupoDestino(''); }} style={{ fontSize: 11, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>Limpiar</button>
          </div>
        )}
      </div>

      {/* Relaciones existentes */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
        <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#5a7a8a' }}>— Organización de contactos ({grupos.length})</div>
        <button onClick={() => abrirCrear()} className="btn-primary" style={{ fontSize: 12, padding: '5px 14px' }}>+ Nueva relación</button>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {grupos.map(g => (
          <div key={g.id} style={{ background: '#fff', border: '1px solid #e8eef2', borderRadius: 2, padding: '12px 16px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 8 }}>
              <div>
                <span style={{ fontWeight: 700, color: '#08293f', fontSize: 14 }}>{g.nombre}</span>
                {g.nit && <span style={{ fontSize: 11, color: '#5a7a8a', marginLeft: 10, background: '#f4f7fa', padding: '2px 8px', borderRadius: 2 }}>NIT {g.nit}</span>}
                {g.notas && <div style={{ fontSize: 11, color: '#b3b3b3', marginTop: 2 }}>{g.notas}</div>}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => abrirEditar(g)} style={{ fontSize: 11, color: '#00b8e3', background: 'none', border: 'none', cursor: 'pointer' }}>Editar</button>
                <button onClick={() => eliminarGrupo(g.id)} style={{ fontSize: 11, color: '#dc2626', background: 'none', border: 'none', cursor: 'pointer' }}>Eliminar</button>
              </div>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
              {g.miembros.map(m => (
                <span key={m} style={{ fontSize: 11, background: 'rgba(0,184,227,0.08)', color: '#0087a8', padding: '3px 10px', borderRadius: 10, border: '1px solid rgba(0,184,227,0.15)' }}>{m}</span>
              ))}
              {g.miembros.length === 0 && <span style={{ fontSize: 11, color: '#b3b3b3' }}>Sin miembros</span>}
            </div>
          </div>
        ))}
        {grupos.length === 0 && <div style={{ textAlign: 'center', padding: '30px 0', color: '#b3b3b3', fontSize: 12 }}>Sin relaciones creadas</div>}
      </div>

      {/* Modal crear/editar relación */}
      {showForm && (
        <div className="modal-overlay">
          <div className="modal" style={{ maxWidth: 520 }}>
            <div style={{ padding: 24 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <h2 style={{ fontSize: 13, fontWeight: 700, color: '#08293f', margin: 0, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                  {editGrupo ? 'Editar relación de contactos' : 'Nueva relación de contactos'}
                </h2>
                <button onClick={() => { setShowForm(false); setSelec(new Set()); }} style={{ fontSize: 20, color: '#b3b3b3', background: 'none', border: 'none', cursor: 'pointer' }}>×</button>
              </div>
              <form onSubmit={guardar}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
                  <div style={{ gridColumn: '1/-1' }}>
                    <label className="label">Nombre *</label>
                    <input className="input" value={form.nombre} style={inp} required onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} />
                  </div>
                  <div>
                    <label className="label">NIT / CC</label>
                    <input className="input" value={form.nit} style={inp} placeholder="Ej: 900123456-1" onChange={e => setForm(f => ({ ...f, nit: e.target.value }))} />
                  </div>
                  <div>
                    <label className="label">Notas</label>
                    <input className="input" value={form.notas} style={inp} onChange={e => setForm(f => ({ ...f, notas: e.target.value }))} />
                  </div>
                </div>
                <div style={{ marginBottom: 16 }}>
                  <label className="label">Clientes / sub-clientes ({selec.size})</label>
                  <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e8eef2', borderRadius: 2, padding: 8, background: '#f9fafb' }}>
                    {clientes.map(c => (
                      <label key={c.cliente} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 6px', cursor: 'pointer', borderRadius: 2, background: selec.has(c.cliente) ? 'rgba(0,184,227,0.06)' : 'transparent' }}>
                        <input type="checkbox" checked={selec.has(c.cliente)} onChange={() => toggleSelec(c.cliente)} style={{ accentColor: '#00b8e3' }} />
                        <span style={{ fontSize: 12, color: '#08293f' }}>{c.cliente}</span>
                        {yaAgrupados.has(c.cliente) && !selec.has(c.cliente) && <span style={{ fontSize: 10, color: '#b45309' }}>en otra relación</span>}
                      </label>
                    ))}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button type="submit" className="btn-primary" style={{ flex: 1, padding: 9 }}>Guardar</button>
                  <button type="button" className="btn-secondary" onClick={() => { setShowForm(false); setSelec(new Set()); }}>Cancelar</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



// ── Tab Cotizaciones ──────────────────────────────────────────────
function TabCotizaciones({ clienteFijo }) {
  const [clientes, setClientes] = useState([]);
  const [listas, setListas] = useState({ servicios: [], proveedores: [] });
  const [buscar, setBuscar] = useState('');
  const [cliente, setCliente] = useState(clienteFijo || '');
  const [textoCotizacion, setTextoCotizacion] = useState('');
  const [fechaDesde, setFechaDesde] = useState('');
  const [fechaHasta, setFechaHasta] = useState('');
  const [estadoFiltro, setEstadoFiltro] = useState('');
  const [cargandoCotizaciones, setCargandoCotizaciones] = useState(false);
  const [cotizaciones, setCotizaciones] = useState([]);
  const [editId, setEditId] = useState(null);
  const [preview, setPreview] = useState(null);
  const [printView, setPrintView] = useState('pdf');
  const [clienteInfo, setClienteInfo] = useState({ nit: '', direccion: '', correo: '' });
  const [convModal, setConvModal] = useState(null);
  const [convForm, setConvForm] = useState({});
  const [convLoading, setConvLoading] = useState(false);
  const [convMsg, setConvMsg] = useState('');
  const [precioRefs, setPrecioRefs] = useState({});
  const precioAutoRefs = useRef({});
  const [form, setForm] = useState({ fecha: new Date().toISOString().slice(0,10), estado: 'BORRADOR', dirigido_a: '', proveedor: '', domicilio: '', garantia: '6 meses', validez_dias: 15, entrega: 'Inmediata', iva_porcentaje: 19, nota: '', items: [{ nombre: '', especificaciones: '', cantidad: 1, costo_unitario: '', precio_unitario: '', imagen: '' }] });
  const inp = { background: '#f4f7fa', border: '1px solid #e8eef2' };
  const domicilio = parseFloat(form.domicilio) || 0;
  const subtotalItems = form.items.reduce((s, it) => s + ((parseFloat(it.cantidad) || 1) * (parseFloat(it.precio_unitario) || 0)), 0);
  const subtotal = subtotalItems + domicilio;
  const costoTotal = form.items.reduce((s, it) => s + ((parseFloat(it.cantidad) || 1) * (parseFloat(it.costo_unitario) || 0)), 0);
  const utilidadInterna = subtotal - costoTotal;
  const rentabilidadInterna = subtotal > 0 ? (utilidadInterna / subtotal) * 100 : 0;
  const ivaPct = Math.max(0, parseFloat(form.iva_porcentaje) || 0);
  const ivaValor = Math.round(subtotal * ivaPct) / 100;
  const total = subtotal + ivaValor;

  const cargarCotizaciones = useCallback(() => {
    setCargandoCotizaciones(true);
    const params = {};
    if (cliente) params.cliente = cliente;
    if (fechaDesde) params.fecha_desde = fechaDesde;
    if (fechaHasta) params.fecha_hasta = fechaHasta;
    if (estadoFiltro) params.estado = estadoFiltro;
    if (textoCotizacion.trim()) params.q = textoCotizacion.trim();
    API.get('/cotizaciones', { params })
      .then(r => setCotizaciones(Array.isArray(r.data) ? r.data : []))
      .catch(() => setCotizaciones([]))
      .finally(() => setCargandoCotizaciones(false));
  }, [cliente, fechaDesde, fechaHasta, estadoFiltro, textoCotizacion]);
  useEffect(() => { API.get('/clientes').then(r => setClientes(Array.isArray(r.data) ? r.data : [])); }, []);
  useEffect(() => { API.get('/listas').then(r => setListas(r.data || { servicios: [], proveedores: [] })).catch(() => {}); }, []);
  useEffect(() => { cargarCotizaciones(); }, [cargarCotizaciones]);
  useEffect(() => {
    if (!cliente) { setClienteInfo({ nit: '', direccion: '', correo: '' }); return; }
    API.get('/clientes/' + encodeURIComponent(cliente) + '/info').then(r => setClienteInfo(r.data || { nit: '', direccion: '', correo: '' })).catch(() => setClienteInfo({ nit: '', direccion: '', correo: '' }));
  }, [cliente]);
  useEffect(() => {
    let cancelado = false;
    const timer = setTimeout(async () => {
      const refs = {};
      await Promise.all((form.items || []).map(async (item, index) => {
        const servicio = String(item.nombre || '').trim();
        if (!servicio) return;
        try {
          const r = await API.get('/servicios/precio-sugerido', { params: { servicio, cliente } });
          if (r.data?.encontrado) refs[index] = r.data;
        } catch {}
      }));
      if (cancelado) return;
      setPrecioRefs(refs);
      if (editId) return;
      setForm(actual => {
        let cambio = false;
        const items = actual.items.map((item, index) => {
          const ref = refs[index];
          if (ref?.precio_sugerido == null) return item;
          const sugerido = String(Math.round(Number(ref.precio_sugerido)));
          if (item.precio_unitario !== '' && String(item.precio_unitario) !== String(precioAutoRefs.current[index])) return item;
          if (String(item.precio_unitario) === sugerido) return item;
          precioAutoRefs.current[index] = sugerido;
          cambio = true;
          return { ...item, precio_unitario: sugerido };
        });
        return cambio ? { ...actual, items } : actual;
      });
    }, 350);
    return () => { cancelado = true; clearTimeout(timer); };
  }, [cliente, editId, form.items]);

  function nueva(c = cliente) {
    setEditId(null);
    setPrecioRefs({});
    precioAutoRefs.current = {};
    setCliente(clienteFijo || c || '');
    setForm({ fecha: new Date().toISOString().slice(0,10), estado: 'BORRADOR', dirigido_a: '', proveedor: '', domicilio: '', garantia: '6 meses', validez_dias: 15, entrega: 'Inmediata', iva_porcentaje: 19, nota: '', items: [{ nombre: '', especificaciones: '', cantidad: 1, costo_unitario: '', precio_unitario: '', imagen: '' }] });
    setPreview(null);
  }
  async function editar(id) {
    const r = await API.get('/cotizaciones/' + id);
    setEditId(id); setCliente(r.data.cliente);
    setPrecioRefs({});
    precioAutoRefs.current = {};
    setForm({ fecha: String(r.data.fecha || '').slice(0,10), estado: r.data.estado || 'BORRADOR', dirigido_a: r.data.dirigido_a || '', proveedor: r.data.proveedor || '', domicilio: r.data.domicilio || '', garantia: r.data.garantia || '6 meses', validez_dias: r.data.validez_dias || 15, entrega: r.data.entrega || 'Inmediata', iva_porcentaje: r.data.iva_porcentaje ?? 19, nota: r.data.nota || '', items: (r.data.items || []).map(it => ({ nombre: it.nombre || '', especificaciones: it.especificaciones || '', cantidad: it.cantidad || 1, costo_unitario: it.costo_unitario || '', precio_unitario: it.precio_unitario || '', imagen: it.imagen || '' })) });
    setPreview(null);
  }
  function scrollCotPreview() {
    setTimeout(() => document.getElementById('cot-preview')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 80);
  }
  async function guardar(e) {
    e.preventDefault();
    const items = form.items.filter(it => (it.nombre || '').trim() && (parseFloat(it.precio_unitario) || 0) >= 0);
    if (!cliente.trim() || !items.length) { alert('Selecciona cliente y agrega al menos un ítem.'); return; }
    const payload = { ...form, cliente: cliente.trim(), items };
    const r = editId ? await API.put('/cotizaciones/' + editId, payload) : await API.post('/cotizaciones', payload);
    setEditId(r.data.id); setPreview(r.data); setPrintView('pdf'); cargarCotizaciones(); scrollCotPreview();
  }
  async function duplicar(id) {
    const r = await API.post('/cotizaciones/' + id + '/duplicar');
    setEditId(r.data.id); setCliente(r.data.cliente);
    await editar(r.data.id); cargarCotizaciones();
  }
  async function eliminar(id) {
    if (!window.confirm('Eliminar esta cotización?')) return;
    await API.delete('/cotizaciones/' + id); if (editId === id) nueva(); cargarCotizaciones();
  }
  async function ver(id) { try { const r = await API.get('/cotizaciones/' + id); setPreview(r.data); setPrintView('pdf'); scrollCotPreview(); } catch (e) { alert('No se pudo cargar la vista PDF de la cotización.'); } }
  async function descargarWhatsApp() {
    if (!preview) return;
    setPrintView('whatsapp');
    setTimeout(async () => {
      try {
        const el = document.getElementById('cot-whatsapp-card');
        if (!el) return;
        const canvas = await html2canvas(el, { backgroundColor: '#ffffff', scale: 2, useCORS: true });
        const dataUrl = canvas.toDataURL('image/jpeg', 0.94);
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = (preview.numero || 'cotizacion') + '-whatsapp.jpg';
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (err) {
        alert('No se pudo descargar la imagen para WhatsApp.');
      }
    }, 120);
  }
  function imprimirCotización(tipo) { setPrintView(tipo); setTimeout(() => window.print(), 80); }
  function updateItem(i, patch) {
    if (Object.prototype.hasOwnProperty.call(patch, 'precio_unitario')) precioAutoRefs.current[i] = null;
    if (Object.prototype.hasOwnProperty.call(patch, 'nombre')) {
      setForm(f => ({ ...f, items: f.items.map((it, idx) => {
        if (idx !== i) return it;
        const precioEraAuto = String(it.precio_unitario || '') === String(precioAutoRefs.current[i] || '');
        return { ...it, ...patch, precio_unitario: precioEraAuto ? '' : it.precio_unitario };
      }) }));
      precioAutoRefs.current[i] = null;
      setPrecioRefs(refs => ({ ...refs, [i]: null }));
      return;
    }
    setForm(f => ({ ...f, items: f.items.map((it, idx) => idx === i ? { ...it, ...patch } : it) }));
  }
  function addItem() { setForm(f => ({ ...f, items: [...f.items, { nombre: '', especificaciones: '', cantidad: 1, costo_unitario: '', precio_unitario: '', imagen: '' }] })); }
  function removeItem(i) {
    precioAutoRefs.current = {};
    setPrecioRefs({});
    setForm(f => ({ ...f, items: f.items.length <= 1 ? f.items : f.items.filter((_, idx) => idx !== i) }));
  }
  function usarPrecioSugerido(i) {
    const ref = precioRefs[i];
    if (ref?.precio_sugerido == null) return;
    const sugerido = String(Math.round(Number(ref.precio_sugerido)));
    precioAutoRefs.current[i] = sugerido;
    setForm(f => ({ ...f, items: f.items.map((it, idx) => idx === i ? { ...it, precio_unitario: sugerido } : it) }));
  }
  function textoOrigenPrecio(ref) {
    if (!ref) return '';
    if (ref.origen === 'cliente') return `precio para ${ref.cliente_precio || cliente}`;
    if (ref.origen === 'base') return 'precio base del servicio';
    if (ref.origen === 'historico') return 'promedio historico del cliente';
    return '';
  }

  async function abrirConversion(id) {
    const r = await API.get('/cotizaciones/' + id);
    const cot = r.data;
    const items = cot.items || [];
    const tieneIva = (parseFloat(cot.iva_porcentaje) || 0) > 0;
    setConvForm({
      fecha: String(cot.fecha || '').slice(0, 10),
      estado: 'PENDIENTE',
      factura: tieneIva ? 'SI' : 'NO',
      con_iva: tieneIva ? 1 : 0,
      proveedor: cot.proveedor || '',
      domicilio: cot.domicilio || '',
      notas: `Ref: Cotizacion ${cot.numero}${cot.nota ? ' - ' + cot.nota : ''}`,
      items: items.map(it => {
        const cantidad = parseFloat(it.cantidad) || 1;
        const precioUnitario = parseFloat(it.precio_unitario) || 0;
        const costoUnitario = parseFloat(it.costo_unitario) || 0;
        return {
          seleccionado: true,
          servicio: it.nombre || 'Producto',
          especificaciones: String(it.especificaciones || '').trim(),
          cantidad,
          precio_unitario: precioUnitario,
          costo_unitario: costoUnitario,
          valor: String(Math.round(cantidad * precioUnitario)),
          costo: String(Math.round(cantidad * costoUnitario)),
        };
      }),
    });
    setConvModal(cot);
    setConvMsg('');
  }

  function updateConvItem(index, patch) {
    setConvForm(f => ({
      ...f,
      items: (f.items || []).map((it, i) => {
        if (i !== index) return it;
        const next = { ...it, ...patch };
        if (Object.prototype.hasOwnProperty.call(patch, 'cantidad')) {
          const cantidad = parseFloat(next.cantidad) || 0;
          const precioUnitario = parseFloat(next.precio_unitario) || 0;
          const costoUnitario = parseFloat(next.costo_unitario) || 0;
          next.valor = String(Math.round(cantidad * precioUnitario));
          next.costo = String(Math.round(cantidad * costoUnitario));
        }
        return next;
      })
    }));
  }

  async function crearRegistroDesde(e) {
    e.preventDefault();
    const itemsSeleccionados = (convForm.items || []).filter(item => item.seleccionado);
    if (!itemsSeleccionados.length) {
      setConvMsg('Selecciona al menos un producto');
      return;
    }
    setConvLoading(true);
    try {
      await API.post(`/cotizaciones/${convModal.id}/convertir-registros`, { ...convForm, items: itemsSeleccionados });
      setConvMsg('ok');
    } catch (err) {
      setConvMsg(err?.response?.data?.error || 'Error al crear el registro');
      setConvLoading(false);
    }
  }
  const convItemsSeleccionados = (convForm.items || []).filter(item => item.seleccionado).length;
  function imageItem(i, file) {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = ev => updateItem(i, { imagen: ev.target.result });
    reader.readAsDataURL(file);
  }

  const filtradas = clientes.filter(c => !buscar || c.cliente.toLowerCase().includes(buscar.toLowerCase())).slice(0, 12);
  const estadoStyle = e => e === 'APROBADA' ? '#059669' : e === 'RECHAZADA' ? '#dc2626' : e === 'ENVIADA' ? '#00b8e3' : '#b45309';
  const totalCotizado = cotizaciones.reduce((s, c) => s + (parseFloat(c.total) || 0), 0);
  const aprobadasCot = cotizaciones.filter(c => c.estado === 'APROBADA').length;
  const ultimoMovimientoCot = cotizaciones[0]?.fecha ? String(cotizaciones[0].fecha).slice(0, 10) : '—';
  const limpiarFiltrosCotizaciones = () => {
    if (!clienteFijo) setCliente('');
    setTextoCotizacion('');
    setFechaDesde('');
    setFechaHasta('');
    setEstadoFiltro('');
  };

  return (<>
    <div style={{ display:'grid', gridTemplateColumns:'minmax(260px, 360px) 1fr', gap:16 }} className="cotizaciones-layout">
      <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
        {!clienteFijo && <div className="card">
          <div style={{ fontSize:10, fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', color:'#5a7a8a', marginBottom:10 }}>— Buscar cliente</div>
          <input className="input" value={buscar} onChange={e => setBuscar(e.target.value)} placeholder="Buscar cliente..." style={inp} />
          <div style={{ display:'grid', gap:6, marginTop:10, maxHeight:300, overflowY:'auto' }}>
            {filtradas.map(c => <button key={c.cliente} onClick={() => { setCliente(c.cliente); nueva(c.cliente); }} style={{ textAlign:'left', background: cliente === c.cliente ? '#08293f' : '#f9fafb', color: cliente === c.cliente ? '#fff' : '#08293f', border:'1px solid #e8eef2', borderRadius:2, padding:'9px 10px', cursor:'pointer', fontWeight:700 }}>{c.cliente}<div style={{ fontSize:10, color: cliente === c.cliente ? 'rgba(255,255,255,0.6)' : '#5a7a8a', marginTop:2 }}>{c.registros} registros</div></button>)}
          </div>
        </div>}
        <div className="card">
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10 }}>
            <div>
              <div style={{ fontSize:10, fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', color:'#5a7a8a' }}>— Histórico{cliente ? ` · ${cliente}` : ''}</div>
              <div style={{ fontSize:11, color:'#8aa0b3', marginTop:3 }}>{cargandoCotizaciones ? 'Cargando cotizaciones...' : `${cotizaciones.length} cotizacion${cotizaciones.length === 1 ? '' : 'es'} encontradas`}</div>
            </div>
            <button className="btn-primary" onClick={() => nueva()} style={{ fontSize:11, padding:'6px 10px' }}>+ Nueva</button>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:7, marginBottom:10 }}>
            {[
              { label:'Cotizaciones', value:cotizaciones.length, dark:true },
              { label:'Total filtrado', value:fmt(totalCotizado), color:'#08293f' },
              { label:'Aprobadas', value:aprobadasCot, color:'#059669' },
            ].map(k => (
              <div key={k.label} style={{ background:k.dark ? '#08293f' : '#fff', border:'1px solid #e8eef2', borderRadius:2, padding:'9px 10px' }}>
                <div style={{ fontSize:8, fontWeight:900, letterSpacing:'0.08em', textTransform:'uppercase', color:k.dark ? 'rgba(0,184,227,0.65)' : '#7f9aad' }}>{k.label}</div>
                <div style={{ fontSize:14, fontWeight:900, color:k.dark ? '#00b8e3' : k.color }}>{k.value}</div>
              </div>
            ))}
          </div>
          <div style={{ display:'grid', gap:7, marginBottom:10 }}>
            <input className="input" value={textoCotizacion} onChange={e => setTextoCotizacion(e.target.value)} placeholder="Buscar por numero, cliente, producto, proveedor o nota..." style={{ ...inp, fontSize:12 }} />
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:7 }}>
              <input className="input" type="date" value={fechaDesde} onChange={e => setFechaDesde(e.target.value)} style={{ ...inp, fontSize:12 }} title="Fecha desde" />
              <input className="input" type="date" value={fechaHasta} onChange={e => setFechaHasta(e.target.value)} style={{ ...inp, fontSize:12 }} title="Fecha hasta" />
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr auto', gap:7, alignItems:'center' }}>
              <select className="input" value={estadoFiltro} onChange={e => setEstadoFiltro(e.target.value)} style={{ ...inp, fontSize:12 }}>
                <option value="">Todos los estados</option>
                <option>BORRADOR</option>
                <option>ENVIADA</option>
                <option>APROBADA</option>
                <option>RECHAZADA</option>
              </select>
              <button type="button" onClick={limpiarFiltrosCotizaciones} className="btn-secondary" style={{ fontSize:11, padding:'8px 10px' }}>Limpiar</button>
            </div>
            {cliente && !clienteFijo && <div style={{ display:'flex', justifyContent:'space-between', gap:8, alignItems:'center', background:'#eef7fb', border:'1px solid #d5edf6', padding:'7px 9px', color:'#315f73', fontSize:11 }}>
              <span>Viendo cotizaciones de <strong>{cliente}</strong></span>
              <button type="button" onClick={() => setCliente('')} style={{ border:'none', background:'transparent', color:'#00b8e3', fontWeight:900, cursor:'pointer', fontFamily:'inherit', fontSize:11 }}>Quitar cliente</button>
            </div>}
          </div>
          <div style={{ display:'grid', gap:7, maxHeight: clienteFijo ? 600 : 360, overflowY:'auto' }}>
            {cotizaciones.map(c => <div key={c.id} style={{ background:'#f9fafb', border:'1px solid #e8eef2', borderRadius:2, padding:10 }}>
              <div style={{ display:'flex', justifyContent:'space-between', gap:8 }}><strong style={{ color:'#08293f', fontSize:13 }}>{c.numero}</strong><span style={{ color:estadoStyle(c.estado), fontSize:10, fontWeight:800 }}>{c.estado}</span></div>
              <div style={{ color:'#5a7a8a', fontSize:11, marginTop:2 }}>{!clienteFijo && <>{c.cliente} · </>}{String(c.fecha || '').slice(0,10)}</div>
              {c.items_nombres && <div style={{ color:'#5a7a8a', fontSize:11, marginTop:3, fontStyle:'italic' }}>{c.items_nombres.length > 60 ? c.items_nombres.slice(0,60) + '…' : c.items_nombres}</div>}
              <div style={{ color:'#08293f', fontWeight:800, fontSize:13, marginTop:5 }}>{fmt(c.total)}</div>
              <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginTop:8 }}>
                <button onClick={() => ver(c.id)} className="btn-secondary" style={{ fontSize:11, padding:'4px 9px' }}>Ver PDF</button>
                <button onClick={() => editar(c.id)} className="btn-secondary" style={{ fontSize:11, padding:'4px 9px', background:'#08293f', color:'#fff' }}>Editar</button>
                <button onClick={() => duplicar(c.id)} className="btn-secondary" style={{ fontSize:11, padding:'4px 9px' }}>Duplicar</button>
                <button onClick={() => eliminar(c.id)} className="btn-secondary" style={{ fontSize:11, padding:'4px 9px', color:'#dc2626' }}>Eliminar</button>
                <button onClick={() => abrirConversion(c.id)} className="btn-secondary" style={{ fontSize:11, padding:'4px 9px', color:'#059669', border:'1px solid rgba(5,150,105,0.35)', fontWeight:800 }}>→ Registro</button>
              </div>
            </div>)}
            {cotizaciones.length === 0 && <div style={{ color:'#b3b3b3', fontSize:12, textAlign:'center', padding:20 }}>Sin cotizaciones para estos filtros</div>}
          </div>
          {ultimoMovimientoCot !== '—' && <div style={{ fontSize:10, color:'#8aa0b3', marginTop:9 }}>Ultima cotizacion encontrada: {ultimoMovimientoCot}</div>}
        </div>
      </div>

      <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
        <form onSubmit={guardar} className="card">
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8, marginBottom:14 }}>
            <div><div style={{ fontSize:10, fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', color:'#5a7a8a' }}>— Cotización</div><h2 style={{ margin:'4px 0 0', color:'#08293f', fontSize:18 }}>{editId ? 'Editar cotización' : 'Nueva cotización'}</h2></div>
            <button type="submit" className="btn-primary" style={{ padding:'8px 16px' }}>Guardar</button>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(5, 1fr)', gap:8, marginBottom:14 }} className="cot-form-grid">
            {[{ label:'Costo AGE', value:fmt(costoTotal), dark:true }, { label:'Subtotal cliente', value:fmt(subtotal) }, { label:'Utilidad', value:fmt(utilidadInterna), color: utilidadInterna >= 0 ? '#059669' : '#dc2626' }, { label:'IVA', value:fmt(ivaValor) }, { label:'Rentabilidad', value:(Number.isFinite(rentabilidadInterna) ? rentabilidadInterna.toFixed(1) : '0.0') + '%', color: rentabilidadInterna >= 0 ? '#059669' : '#dc2626' }].map(k => <div key={k.label} style={{ background:k.dark ? '#08293f' : '#fff', border:k.dark ? '1px solid rgba(0,184,227,0.2)' : '1px solid #e8eef2', borderRadius:2, padding:'10px 12px' }}><div style={{ fontSize:9, fontWeight:800, letterSpacing:'0.08em', textTransform:'uppercase', color:k.dark ? 'rgba(0,184,227,0.65)' : '#5a7a8a', marginBottom:3 }}>{k.label}</div><div style={{ fontSize:15, fontWeight:900, color:k.dark ? '#00b8e3' : (k.color || '#08293f') }}>{k.value}</div></div>)}
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'2fr 1fr 1fr 1fr', gap:10, marginBottom:12 }} className="cot-form-grid">
            <div><label className="label">Cliente *</label><input className="input" list={clienteFijo ? undefined : 'cot-clientes-list'} value={cliente} onChange={e => !clienteFijo && setCliente(e.target.value)} readOnly={!!clienteFijo} style={{ ...inp, ...(clienteFijo ? { background:'#eef3f8', color:'#5a7a8a', cursor:'default' } : {}) }} required />{!clienteFijo && <datalist id="cot-clientes-list">{clientes.map(c => <option key={c.cliente} value={c.cliente} />)}</datalist>}</div>
            <div><label className="label">Fecha</label><input className="input" type="date" value={form.fecha} onChange={e => setForm(f => ({ ...f, fecha:e.target.value }))} style={inp} /></div>
            <div><label className="label">Estado</label><select className="input" value={form.estado} onChange={e => setForm(f => ({ ...f, estado:e.target.value }))} style={inp}><option>BORRADOR</option><option>ENVIADA</option><option>APROBADA</option><option>RECHAZADA</option></select></div>
            <div><label className="label">Garantía</label><select className="input" value={form.garantia} onChange={e => setForm(f => ({ ...f, garantia:e.target.value }))} style={inp}><option>3 meses</option><option>6 meses</option><option>1 año</option><option>2 años</option><option>Sin garantía</option></select></div>
            <div><label className="label">Validez dias</label><input className="input" type="number" min="1" value={form.validez_dias} onChange={e => setForm(f => ({ ...f, validez_dias:e.target.value }))} style={inp} /></div>
            <div><label className="label">Entrega</label><input className="input" value={form.entrega} onChange={e => setForm(f => ({ ...f, entrega:e.target.value }))} style={inp} /></div>
            <div><label className="label">IVA %</label><input className="input" type="number" min="0" value={form.iva_porcentaje} onChange={e => setForm(f => ({ ...f, iva_porcentaje:e.target.value }))} style={inp} /></div>
            <div><label className="label">Dirigido a <span style={{ color:'#b3b3b3', fontWeight:400 }}>(opcional)</span></label><input className="input" value={form.dirigido_a} onChange={e => setForm(f => ({ ...f, dirigido_a:e.target.value }))} placeholder="Solo si va para otra persona/area" style={inp} /></div>
            <div><label className="label">Proveedor</label><CompactAutocomplete value={form.proveedor} onChange={value => setForm(f => ({ ...f, proveedor:value }))} options={listas.proveedores || []} inputStyle={inp} placeholder="Escribe 3 letras" newItemLabel="proveedor nuevo" /></div>
            <div><label className="label">Domicilio</label><input className="input" type="number" min="0" value={form.domicilio} onChange={e => setForm(f => ({ ...f, domicilio:e.target.value }))} style={inp} /></div>
            <div style={{ gridColumn:'span 2' }}><label className="label">Nota</label><input className="input" value={form.nota} onChange={e => setForm(f => ({ ...f, nota:e.target.value }))} style={inp} /></div>
          </div>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', margin:'8px 0 10px' }}><div style={{ fontSize:10, fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', color:'#5a7a8a' }}>— Servicios / productos</div><button type="button" onClick={addItem} className="btn-secondary">+ Servicio</button></div>
          <div style={{ display:'grid', gap:10 }}>
            {form.items.map((it, i) => <div key={i} style={{ border:'1px solid #e8eef2', borderRadius:2, padding:12, background:'#f9fafb' }}>
              <div style={{ display:'grid', gridTemplateColumns:'1.3fr 80px 130px 130px auto', gap:8, alignItems:'end' }} className="cot-item-grid">
                <div><label className="label">Servicio / producto</label><CompactAutocomplete value={it.nombre} onChange={value => updateItem(i, { nombre:value })} options={listas.servicios_busqueda || listas.servicios || []} inputStyle={{ background:'#fff', border:'1px solid #e8eef2' }} placeholder="Escribe 3 letras para buscar servicio" newItemLabel="servicio nuevo" required /></div>
                <div><label className="label">Cant.</label><input className="input" type="number" min="1" value={it.cantidad} onChange={e => updateItem(i, { cantidad:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} /></div>
                <div><label className="label">Costo AGE</label><input className="input" type="number" min="0" value={it.costo_unitario} onChange={e => updateItem(i, { costo_unitario:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} /></div><div><label className="label">Precio cliente</label><input className="input" type="number" min="0" value={it.precio_unitario} onChange={e => updateItem(i, { precio_unitario:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} /></div>
                <button type="button" onClick={() => removeItem(i)} className="btn-secondary" style={{ color:'#dc2626' }}>Quitar</button>
              </div>
              {precioRefs[i] && <div style={{ marginTop:8, padding:'8px 10px', background:'#eefaf5', border:'1px solid #cde9dd', color:'#315f50', fontSize:11, display:'flex', justifyContent:'space-between', gap:10, alignItems:'center', flexWrap:'wrap' }}>
                <div>
                  <strong style={{ color:'#047857' }}>Sugerido: {precioRefs[i].precio_sugerido != null ? fmt(precioRefs[i].precio_sugerido) : 'sin valor definido'}</strong>
                  <span style={{ marginLeft:6 }}>{textoOrigenPrecio(precioRefs[i])}</span>
                  {precioRefs[i].historico?.registros > 0 && <div style={{ color:'#6b8295', marginTop:3 }}>Historico relacionado: {precioRefs[i].historico.registros} registro(s), promedio {fmt(precioRefs[i].historico.promedio)}</div>}
                </div>
                {precioRefs[i].precio_sugerido != null && String(Math.round(Number(precioRefs[i].precio_sugerido))) !== String(it.precio_unitario) && (
                  <button type="button" onClick={() => usarPrecioSugerido(i)} style={{ border:'1px solid #9fd3bd', background:'#fff', color:'#047857', padding:'5px 8px', cursor:'pointer', fontWeight:800, fontSize:10, fontFamily:'inherit' }}>Usar sugerido</button>
                )}
              </div>}
              <div style={{ display:'grid', gridTemplateColumns:'repeat(3, 1fr)', gap:8, marginTop:8 }} className="cot-form-grid">
                {(() => { const qty = parseFloat(it.cantidad) || 1; const cost = parseFloat(it.costo_unitario) || 0; const price = parseFloat(it.precio_unitario) || 0; const util = (price - cost) * qty; const rent = price > 0 ? ((price - cost) / price) * 100 : 0; return <>
                  <div style={{ background:'#fff', border:'1px solid #e8eef2', padding:'7px 9px', borderRadius:2 }}><div style={{ fontSize:9, color:'#5a7a8a', fontWeight:800, textTransform:'uppercase' }}>Utilidad ítem</div><strong style={{ color: util >= 0 ? '#059669' : '#dc2626' }}>{fmt(util)}</strong></div>
                  <div style={{ background:'#fff', border:'1px solid #e8eef2', padding:'7px 9px', borderRadius:2 }}><div style={{ fontSize:9, color:'#5a7a8a', fontWeight:800, textTransform:'uppercase' }}>Rentabilidad</div><strong style={{ color: rent >= 0 ? '#059669' : '#dc2626' }}>{Number.isFinite(rent) ? rent.toFixed(1) : '0.0'}%</strong></div>
                  <div style={{ background:'#fff', border:'1px solid #e8eef2', padding:'7px 9px', borderRadius:2 }}><div style={{ fontSize:9, color:'#5a7a8a', fontWeight:800, textTransform:'uppercase' }}>Total cliente</div><strong style={{ color:'#08293f' }}>{fmt(price * qty)}</strong></div>
                </>; })()}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 190px', gap:8, marginTop:8 }} className="cot-item-grid">
                <textarea className="input" rows="4" placeholder="Especificaciones técnicas" value={it.especificaciones} onChange={e => updateItem(i, { especificaciones:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2', resize:'vertical' }} />
                <div><label className="label">Imagen</label><input className="input" type="file" accept="image/*" onChange={e => imageItem(i, e.target.files[0])} style={{ background:'#fff', border:'1px solid #e8eef2' }} />{it.imagen && <div style={{ marginTop:6 }}><img src={it.imagen} alt="" style={{ maxWidth:'100%', maxHeight:80, objectFit:'contain', border:'1px solid #e8eef2', background:'#fff' }} /><button type="button" onClick={() => updateItem(i, { imagen: '' })} className="btn-secondary" style={{ marginTop:6, width:'100%', fontSize:11, padding:'5px 8px', color:'#dc2626' }}>Quitar imagen</button></div>}</div>
              </div>
            </div>)}
          </div>
          <div style={{ display:'grid', justifyContent:'end', gap:4, marginTop:14, color:'#08293f', fontSize:13 }}>
            <div style={{ textAlign:'right' }}>Servicios/productos: <strong>{fmt(subtotalItems)}</strong></div>
            {!!domicilio && <div style={{ textAlign:'right' }}>Domicilio: <strong>{fmt(domicilio)}</strong></div>}
            <div style={{ textAlign:'right' }}>Subtotal: <strong>{fmt(subtotal)}</strong></div>
            <div style={{ textAlign:'right' }}>IVA ({ivaPct}%): <strong>{fmt(ivaValor)}</strong></div>
            <div style={{ textAlign:'right', fontSize:18, fontWeight:900 }}>Total con IVA: {fmt(total)}</div>
          </div>
        </form>

        {preview && printView !== 'whatsapp' && <div id="cot-preview" className="card cot-print-area" style={{ padding:0, overflow:'hidden', border:'1px solid #d8e5ec', borderRadius:6, boxShadow:'0 12px 34px rgba(8,41,63,0.08)' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-end', gap:18, padding:'24px 28px', background:'#08293f', color:'#fff' }}>
            <div>
              <div style={{ display:'flex', alignItems:'baseline', gap:5, fontWeight:800, letterSpacing:3 }}>
                <span style={{ color:'#00b8e3', letterSpacing:-2, fontSize:22 }}>{'//'}</span>
                <span style={{ color:'#fff', fontSize:18 }}>AGE</span>
                <span style={{ color:'rgba(255,255,255,0.58)', fontSize:9, fontWeight:400 }}>INFORMATICA</span>
              </div>
            </div>
            <div style={{ textAlign:'right', color:'rgba(255,255,255,0.72)', fontSize:12 }}>
              <strong style={{ color:'#fff', display:'block', fontSize:18, marginBottom:4 }}>Cotización {preview.numero}</strong>
              {String(preview.fecha || '').slice(0,10)}
            </div>
          </div>

          <div style={{ padding:'18px 28px 16px', borderBottom:'1px solid #d8e5ec', background:'#f8fbfd' }}>
            <h3 style={{ margin:'0 0 5px', fontSize:16, fontWeight:900, color:'#08293f' }}>AGE Informática</h3>
            <div style={{ display:'grid', gap:2, color:'#5a7a8a', fontSize:12, lineHeight:1.45 }}>
              <span>Soporte técnico, mantenimiento e infraestructura TI</span>
              <span>Correo: info@ageinformatica.com</span>
              <span>Celular: 313 3030874</span>
              <span>Web: https://ageinformatica.com</span>
              <span>Medellín, Colombia</span>
            </div>
          </div>

          <div style={{ padding:'20px 28px 8px' }}>
            <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.12em', fontWeight:900, color:'#7f9aad', marginBottom:8 }}>Cotización para</div>
            <h2 style={{ margin:0, fontSize:22, color:'#08293f' }}>{preview.cliente}</h2>
            {(() => { const info = preview.cliente_info || clienteInfo || {}; return (info.nit || info.direccion || info.correo) ? <div style={{ marginTop:8, display:'grid', gap:2, color:'#5a7a8a', fontSize:12, lineHeight:1.45 }}>
              {info.nit && <span>NIT / CC: {info.nit}</span>}
              {info.direccion && <span>Dirección: {info.direccion}</span>}
              {info.correo && <span>Correo: {info.correo}</span>}
            </div> : null; })()}
          </div>

          <div style={{ padding:'20px 28px', display:'grid', gridTemplateColumns: preview.dirigido_a ? '1.6fr repeat(3, 1fr)' : 'repeat(3, 1fr)', gap:12, borderBottom:'1px solid #d8e5ec' }} className="cot-form-grid">
            {preview.dirigido_a && <div style={{ background:'#f4f7fa', border:'1px solid #e8eef2', borderRadius:5, padding:'11px 13px' }}>
              <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.1em', color:'#7f9aad', fontWeight:800 }}>Dirigido a</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#08293f' }}>{preview.dirigido_a || '-'}</div>
            </div>}
            <div style={{ background:'#f4f7fa', border:'1px solid #e8eef2', borderRadius:5, padding:'11px 13px' }}>
              <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.1em', color:'#7f9aad', fontWeight:800 }}>Garantía</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#08293f' }}>{preview.garantia || '-'}</div>
            </div>
            <div style={{ background:'#f4f7fa', border:'1px solid #e8eef2', borderRadius:5, padding:'11px 13px' }}>
              <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.1em', color:'#7f9aad', fontWeight:800 }}>Validez</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#08293f' }}>{preview.validez_dias || 15} dias</div>
            </div>
            <div style={{ background:'#f4f7fa', border:'1px solid #e8eef2', borderRadius:5, padding:'11px 13px' }}>
              <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.1em', color:'#7f9aad', fontWeight:800 }}>Entrega</div>
              <div style={{ fontSize:13, fontWeight:800, color:'#08293f' }}>{preview.entrega || '-'}</div>
            </div>
          </div>

          <div style={{ padding:'22px 28px 0' }}>
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13, minWidth:760 }}>
                <thead>
                  <tr>
                    {['Producto','Cant.','Precio unit.','Subtotal'].map((h, idx) => (
                      <th key={h} style={{ textAlign: idx > 0 ? 'right' : 'left', color:'#7f9aad', fontSize:10, letterSpacing:'0.09em', textTransform:'uppercase', borderBottom:'1px solid #d8e5ec', padding:'10px 12px' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(preview.items || []).map((it, i) => (
                    <tr key={i}>
                      <td style={{ padding:'13px 12px', borderBottom:'1px solid #edf3f6', verticalAlign:'top' }}>
                        <div style={{ display:'grid', gridTemplateColumns: it.imagen ? '58px 1fr' : '1fr', gap:12 }}>
                          {it.imagen && <img src={it.imagen} alt="" style={{ width:58, height:44, borderRadius:4, border:'1px solid #d8e5ec', objectFit:'cover', background:'#eef4f7' }} />}
                          <div>
                            <div style={{ fontWeight:900, color:'#08293f' }}>{it.nombre}</div>
                            {it.especificaciones && <div style={{ marginTop:5, color:'#5a7a8a', lineHeight:1.45, fontSize:12, whiteSpace:'pre-wrap' }}>{it.especificaciones}</div>}
                          </div>
                        </div>
                      </td>
                      <td style={{ padding:'13px 12px', borderBottom:'1px solid #edf3f6', textAlign:'right', whiteSpace:'nowrap' }}>{it.cantidad}</td>
                      <td style={{ padding:'13px 12px', borderBottom:'1px solid #edf3f6', textAlign:'right', whiteSpace:'nowrap' }}>{fmt(it.precio_unitario)}</td>
                      <td style={{ padding:'13px 12px', borderBottom:'1px solid #edf3f6', textAlign:'right', whiteSpace:'nowrap', fontWeight:800 }}>{fmt((parseFloat(it.cantidad)||1) * (parseFloat(it.precio_unitario)||0))}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {preview.nota && <div style={{ margin:'16px 28px 0', borderLeft:'3px solid #00b8e3', padding:'10px 14px', background:'#f8fbfd', color:'#5a7a8a', fontSize:12, lineHeight:1.5 }}>{preview.nota}</div>}

          <div className="cot-print-totals" style={{ display:'grid', justifyContent:'end', gap:6, padding:'18px 22px 24px' }}>
            {!!parseFloat(preview.domicilio || 0) && <div style={{ display:'grid', gridTemplateColumns:'130px 150px', gap:16, fontSize:13 }}>
              <span style={{ color:'#5a7a8a', textAlign:'right' }}>Servicios</span>
              <strong style={{ textAlign:'right' }}>{fmt(Math.max(0, (parseFloat(preview.subtotal)||0) - (parseFloat(preview.domicilio)||0)))}</strong>
            </div>}
            {!!parseFloat(preview.domicilio || 0) && <div style={{ display:'grid', gridTemplateColumns:'130px 150px', gap:16, fontSize:13 }}>
              <span style={{ color:'#5a7a8a', textAlign:'right' }}>Domicilio</span>
              <strong style={{ textAlign:'right' }}>{fmt(preview.domicilio)}</strong>
            </div>}
            <div style={{ display:'grid', gridTemplateColumns:'130px 150px', gap:16, fontSize:13 }}>
              <span style={{ color:'#5a7a8a', textAlign:'right' }}>Subtotal</span>
              <strong style={{ textAlign:'right' }}>{fmt(preview.subtotal ?? Math.max(0, (parseFloat(preview.total)||0) - (parseFloat(preview.iva_valor)||0)))}</strong>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'130px 150px', gap:16, fontSize:13 }}>
              <span style={{ color:'#5a7a8a', textAlign:'right' }}>IVA {preview.iva_porcentaje ?? 19}%</span>
              <strong style={{ textAlign:'right' }}>{fmt(preview.iva_valor || 0)}</strong>
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'130px 150px', gap:16, background:'#f4f7fa', color:'#08293f', border:'1px solid #d8e5ec', padding:'12px 14px', borderRadius:5, fontSize:18 }}>
              <span style={{ color:'#5a7a8a', textAlign:'right' }}>Total con IVA</span>
              <strong style={{ textAlign:'right' }}>{fmt(preview.total)}</strong>
            </div>
          </div>

          <div className="no-print" style={{ display:'flex', justifyContent:'flex-end', gap:8, padding:'0 28px 24px', flexWrap:'wrap' }}>
            <button onClick={() => imprimirCotización('pdf')} className="btn-primary">Imprimir / PDF</button>
            <button onClick={descargarWhatsApp} className="btn-secondary" style={{ background:'#08293f', color:'#fff', borderColor:'#08293f' }}>WhatsApp</button>
          </div>
        </div>}

        {preview && printView === 'whatsapp' && <div id="cot-preview" className="card cot-print-area cot-whatsapp-print" style={{ width:420, maxWidth:'100%', margin:'0 auto', padding:0, overflow:'hidden', border:'1px solid #d8e5ec', borderRadius:10, boxShadow:'0 18px 40px rgba(8,41,63,0.12)' }}><div id="cot-whatsapp-card" style={{ background:'#fff' }}>
          <div style={{ background:'#08293f', color:'#fff', padding:'18px 20px 16px' }}>
            <div style={{ display:'flex', alignItems:'baseline', gap:5, fontWeight:800, letterSpacing:3 }}>
              <span style={{ color:'#00b8e3', letterSpacing:-2, fontSize:22 }}>{'//'}</span>
              <span style={{ color:'#fff', fontSize:18 }}>AGE</span>
              <span style={{ color:'rgba(255,255,255,0.58)', fontSize:9, fontWeight:400 }}>INFORMATICA</span>
            </div>
            <div style={{ marginTop:20, display:'grid', gap:3 }}>
              <strong style={{ fontSize:20 }}>Cotización {preview.numero}</strong>
              <span style={{ color:'rgba(255,255,255,0.68)', fontSize:12 }}>{String(preview.fecha || '').slice(0,10)}</span>
            </div>
          </div>
          <div style={{ padding:'14px 18px', background:'#f8fbfd', borderBottom:'1px solid #d8e5ec', fontSize:12, color:'#5a7a8a', lineHeight:1.5 }}>
            <strong style={{ display:'block', color:'#08293f', fontSize:15, marginBottom:2 }}>AGE Informática</strong>
            Soporte técnico, mantenimiento e infraestructura TI<br />
            info@ageinformatica.com · 313 3030874<br />
            https://ageinformatica.com · Medellín, Colombia
          </div>
          <div style={{ padding:'16px 18px 10px' }}>
            <div style={{ fontSize:10, textTransform:'uppercase', letterSpacing:'0.12em', fontWeight:900, color:'#7f9aad', marginBottom:5 }}>Cotización para</div>
            <h2 style={{ margin:0, fontSize:20, color:'#08293f' }}>{preview.cliente}</h2>
            {(() => { const info = preview.cliente_info || clienteInfo || {}; return (info.nit || info.direccion || info.correo) ? <div style={{ marginTop:6, color:'#5a7a8a', fontSize:12, lineHeight:1.45 }}>
              {info.nit && <><span>NIT / CC: {info.nit}</span><br /></>}
              {info.direccion && <><span>Dirección: {info.direccion}</span><br /></>}
              {info.correo && <span>Correo: {info.correo}</span>}
            </div> : null; })()}
          </div>
          <div style={{ padding:'0 18px 14px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
            {[...(preview.dirigido_a ? [['Dirigido a', preview.dirigido_a]] : []), ['Garantía', preview.garantia || '-'], ['Validez', (preview.validez_dias || 15) + ' días'], ['Entrega', preview.entrega || '-']].map(([label, value]) => <div key={label} style={{ background:'#f4f7fa', border:'1px solid #d8e5ec', borderRadius:6, padding:'9px 10px' }}><small style={{ display:'block', color:'#7f9aad', fontSize:9, textTransform:'uppercase', letterSpacing:'0.08em', fontWeight:900, marginBottom:2 }}>{label}</small><strong style={{ color:'#08293f', fontSize:12 }}>{value}</strong></div>)}
          </div>
          <div style={{ padding:'0 18px', display:'grid', gap:8 }}>
            {(preview.items || []).map((it, i) => <div key={i} style={{ border:'1px solid #d8e5ec', background:'#fff', borderRadius:7, padding:10, display:'grid', gridTemplateColumns: it.imagen ? '48px 1fr' : '1fr', gap:10 }}>
              {it.imagen && <img src={it.imagen} alt="" style={{ width:48, height:48, objectFit:'cover', borderRadius:5, border:'1px solid #d8e5ec' }} />}
              <div>
                <h3 style={{ margin:0, fontSize:13, color:'#08293f' }}>{it.nombre}</h3>
                {it.especificaciones && <p style={{ margin:'3px 0 8px', fontSize:11, color:'#5a7a8a', lineHeight:1.35, whiteSpace:'pre-wrap' }}>{it.especificaciones}</p>}
                <div style={{ display:'flex', justifyContent:'space-between', gap:10, fontSize:12 }}><span>{it.cantidad} x {fmt(it.precio_unitario)}</span><strong style={{ color:'#08293f' }}>{fmt((parseFloat(it.cantidad)||1) * (parseFloat(it.precio_unitario)||0))}</strong></div>
              </div>
            </div>)}
          </div>
          <div style={{ margin:'14px 18px 0', display:'grid', gap:6 }}>
            {!!parseFloat(preview.domicilio || 0) && <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'#5a7a8a' }}><span>Servicios</span><strong style={{ color:'#08293f' }}>{fmt(Math.max(0, (parseFloat(preview.subtotal)||0) - (parseFloat(preview.domicilio)||0)))}</strong></div>}
            {!!parseFloat(preview.domicilio || 0) && <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'#5a7a8a' }}><span>Domicilio</span><strong style={{ color:'#08293f' }}>{fmt(preview.domicilio)}</strong></div>}
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'#5a7a8a' }}><span>Subtotal</span><strong style={{ color:'#08293f' }}>{fmt(preview.subtotal ?? Math.max(0, (parseFloat(preview.total)||0) - (parseFloat(preview.iva_valor)||0)))}</strong></div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'#5a7a8a' }}><span>IVA {preview.iva_porcentaje ?? 19}%</span><strong style={{ color:'#08293f' }}>{fmt(preview.iva_valor || 0)}</strong></div>
            <div style={{ background:'#f4f7fa', border:'1px solid #d8e5ec', borderRadius:7, padding:12, display:'flex', justifyContent:'space-between', fontSize:16, fontWeight:900, color:'#08293f' }}><span>Total</span><strong>{fmt(preview.total)}</strong></div>
          </div>
          {preview.nota && <div style={{ margin:'14px 18px 0', borderLeft:'3px solid #00b8e3', padding:'9px 11px', background:'#f8fbfd', color:'#5a7a8a', fontSize:11, lineHeight:1.45 }}>{preview.nota}</div>}
          <div style={{ marginTop:16, padding:'14px 18px', background:'#08293f', color:'rgba(255,255,255,0.74)', fontSize:11, lineHeight:1.5 }}>
            <strong style={{ color:'#fff' }}>AGE Informática</strong><br />
            Esta cotización no constituye factura de venta.
          </div>
          </div><div className="no-print" style={{ display:'flex', justifyContent:'flex-end', gap:8, padding:'14px 18px', flexWrap:'wrap' }}>
            <button onClick={() => setPrintView('pdf')} className="btn-secondary">Ver PDF formal</button>
            <button onClick={descargarWhatsApp} className="btn-primary">Descargar JPG</button>
            <button onClick={() => abrirConversion(preview.id)} className="btn-secondary" style={{ color:'#059669', border:'1px solid rgba(5,150,105,0.35)', fontWeight:800 }}>Convertir a registro</button>
          </div>
        </div>}
      </div>
    </div>

    {/* ── Modal: Convertir cotizacion a registro ── */}
    {convModal && (<div style={{ position:'fixed', inset:0, zIndex:1000, background:'rgba(8,41,63,0.45)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={() => !convLoading && setConvModal(null)}>
        <div style={{ background:'#fff', borderRadius:10, padding:24, width:'100%', maxWidth:680, maxHeight:'90vh', overflowY:'auto', boxShadow:'0 8px 32px rgba(0,0,0,0.18)' }} onClick={e => e.stopPropagation()}>
          {convMsg === 'ok' ? (
            <div style={{ textAlign:'center', padding:'20px 0' }}>
              <div style={{ fontSize:40, marginBottom:12 }}>✓</div>
              <div style={{ fontSize:16, fontWeight:800, color:'#059669', marginBottom:6 }}>Registros creados</div>
              <div style={{ fontSize:13, color:'#5a7a8a', marginBottom:20 }}>La cotizacion {convModal.numero} fue convertida en {convItemsSeleccionados} registro(s), uno por producto seleccionado.</div>
              <button onClick={() => setConvModal(null)} className="btn-primary" style={{ padding:'8px 24px' }}>Cerrar</button>
            </div>
          ) : (
            <form onSubmit={crearRegistroDesde}>
              <div style={{ fontSize:10, fontWeight:800, letterSpacing:'0.1em', textTransform:'uppercase', color:'#5a7a8a', marginBottom:4 }}>Convertir a registro</div>
              <h3 style={{ margin:'0 0 16px', color:'#08293f', fontSize:16 }}>{convModal.numero} · {convModal.cliente}</h3>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
                <div><label className="label">Fecha</label><input className="input" type="date" value={convForm.fecha} onChange={e => setConvForm(f => ({ ...f, fecha:e.target.value }))} style={{ background:'#f4f7fa', border:'1px solid #e8eef2' }} required /></div>
                <div><label className="label">Estado</label><select className="input" value={convForm.estado} onChange={e => setConvForm(f => ({ ...f, estado:e.target.value }))} style={{ background:'#f4f7fa', border:'1px solid #e8eef2' }}><option>PENDIENTE</option><option>PAGADO</option><option>FACTURADO</option></select></div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
                <div><label className="label">Proveedor</label><CompactAutocomplete value={convForm.proveedor || ''} onChange={value => setConvForm(f => ({ ...f, proveedor:value }))} options={listas.proveedores || []} inputStyle={{ background:'#f4f7fa', border:'1px solid #e8eef2' }} placeholder="Escribe 3 letras" newItemLabel="proveedor nuevo" /></div>
                <div><label className="label">Domicilio</label><input className="input" type="number" min="0" value={convForm.domicilio || ''} onChange={e => setConvForm(f => ({ ...f, domicilio:e.target.value }))} style={{ background:'#f4f7fa', border:'1px solid #e8eef2' }} /></div>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', gap:8, marginBottom:8 }}>
                <span style={{ fontSize:11, fontWeight:800, color:'#5a7a8a' }}>{convItemsSeleccionados} de {convForm.items?.length || 0} productos seleccionados</span>
                <div style={{ display:'flex', gap:6 }}>
                  <button type="button" onClick={() => setConvForm(f => ({ ...f, items:f.items.map(item => ({ ...item, seleccionado:true })) }))} className="btn-secondary" style={{ fontSize:10, padding:'4px 8px' }}>Seleccionar todos</button>
                  <button type="button" onClick={() => setConvForm(f => ({ ...f, items:f.items.map(item => ({ ...item, seleccionado:false })) }))} className="btn-secondary" style={{ fontSize:10, padding:'4px 8px' }}>Limpiar</button>
                </div>
              </div>
              <div style={{ display:'grid', gap:8, marginBottom:12 }}>
                {(convForm.items || []).map((item, index) => (
                  <div key={index} style={{ border:`1px solid ${item.seleccionado ? 'rgba(5,150,105,0.35)' : '#e8eef2'}`, background:item.seleccionado ? 'rgba(5,150,105,0.035)' : '#f9fafb', padding:10, borderRadius:4, opacity:item.seleccionado ? 1 : 0.58 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', gap:8, marginBottom:8 }}>
                      <label style={{ display:'flex', alignItems:'center', gap:8, color:'#08293f', fontSize:12, fontWeight:800, cursor:'pointer' }}>
                        <input type="checkbox" checked={!!item.seleccionado} onChange={e => updateConvItem(index, { seleccionado:e.target.checked })} style={{ accentColor:'#059669' }} />
                        Producto {index + 1}
                      </label>
                      <label style={{ display:'flex', alignItems:'center', gap:6, color:'#5a7a8a', fontSize:11, fontWeight:800 }}>
                        Cant.
                        <input className="input" type="number" min="0" step="0.01" value={item.cantidad} disabled={!item.seleccionado} onChange={e => updateConvItem(index, { cantidad:e.target.value })} style={{ width:82, height:28, padding:'4px 7px', background:'#fff', border:'1px solid #e8eef2' }} />
                      </label>
                    </div>
                    <div style={{ marginBottom:8 }}><label className="label">Servicio</label><input className="input" value={item.servicio} disabled={!item.seleccionado} onChange={e => updateConvItem(index, { servicio:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} required /></div>
                    {item.especificaciones && <div style={{ fontSize:11, color:'#5a7a8a', lineHeight:1.45, marginBottom:8 }}>{item.especificaciones}</div>}
                    <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
                      <div><label className="label">Valor total (sin IVA)</label><input className="input" type="number" value={item.valor} disabled={!item.seleccionado} onChange={e => updateConvItem(index, { valor:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} required /></div>
                      <div><label className="label">Costo AGE total</label><input className="input" type="number" value={item.costo} disabled={!item.seleccionado} onChange={e => updateConvItem(index, { costo:e.target.value })} style={{ background:'#fff', border:'1px solid #e8eef2' }} /></div>
                    </div>
                  </div>
                ))}
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
                <div><label className="label">Factura</label><select className="input" value={convForm.factura} onChange={e => setConvForm(f => ({ ...f, factura:e.target.value, con_iva: e.target.value === 'SI' ? 1 : 0 }))} style={{ background:'#f4f7fa', border:'1px solid #e8eef2' }}><option>NO</option><option>SI</option></select></div>
                <div style={{ display:'flex', alignItems:'flex-end', paddingBottom:2 }}><span style={{ fontSize:11, color:'#5a7a8a' }}>{convForm.factura === 'SI' ? `IVA 19% incluido` : 'Sin IVA'}</span></div>
              </div>
              <div style={{ marginBottom:16 }}><label className="label">Notas</label><input className="input" value={convForm.notas} onChange={e => setConvForm(f => ({ ...f, notas:e.target.value }))} style={{ background:'#f4f7fa', border:'1px solid #e8eef2' }} /></div>
              {convMsg && <div style={{ color:'#dc2626', fontSize:12, marginBottom:10 }}>{convMsg}</div>}
              <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
                <button type="button" onClick={() => setConvModal(null)} className="btn-secondary" disabled={convLoading}>Cancelar</button>
                <button type="submit" className="btn-primary" disabled={convLoading || !convItemsSeleccionados} style={{ background:'#059669', opacity:convItemsSeleccionados ? 1 : 0.55 }}>{convLoading ? 'Creando...' : `Crear ${convItemsSeleccionados} registro(s)`}</button>
              </div>
            </form>
          )}
        </div>
      </div>
    )}
  </>);
}

// ── Página principal ──────────────────────────────────────────────
export default function Clientes() {
  const [tab, setTab] = useState('clientes');

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <h1 style={{ fontSize: 20, fontWeight: 700, color: '#08293f', margin: 0 }}>Clientes</h1>
      </div>

      <div style={{ display: 'flex', gap: 0, borderBottom: '2px solid #e8eef2', marginBottom: 20 }}>
        {[{ key: 'clientes', label: 'Clientes' }, { key: 'cotizaciones', label: 'Cotizaciones' }].map(t => (
          <button key={t.key} onClick={() => setTab(t.key)} style={{
            padding: '8px 18px', fontSize: 12, fontWeight: 600, letterSpacing: '0.04em',
            fontFamily: "'Space Grotesk', sans-serif", cursor: 'pointer',
            background: 'transparent', border: 'none',
            color: tab === t.key ? '#08293f' : '#5a7a8a',
            borderBottom: tab === t.key ? '2px solid #00b8e3' : '2px solid transparent',
            marginBottom: -2, transition: 'all 0.15s',
          }}>{t.label}</button>
        ))}
      </div>

      {tab === 'clientes' && <TabClientes />}
      {tab === 'cotizaciones' && <TabCotizaciones />}
    </div>
  );
}
